// export const GAME_HELP_GUIDE = {
//   en: [
//     {
//       value: 'COCKFIGHTING CHALLENGE',
//       class: 'h1',
//     },
//     {
//       value: '<span class="badge bg-red p-8 br-4">Banker</span>',
//       class: '',
//     },
//     {
//       value: `The <span class="text-red">Banker</span> roosters start on the
//                 <span class="bold"> Left </span> side of the live stream.`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-blue p-8 br-4">Player</span>',
//       class: '',
//     },
//     {
//       value: `The <span class="text-blue">Player</span> roosters start on the
//                 <span class="bold">Right</span> side of the live stream.`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-green p-8 br-4">Draw</span>',
//       class: '',
//     },
//     {
//       value: `If neither rooster successfully pecks twice during
//                 the Carreo Procedure (3 up & 3 down system) or if no winner is
//                 declared after ten (10) minutes from the first contact, there will be no declared winner.`,
//       class: 'inline ',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'BET GUIDE',
//       class: 'h1',
//     },
//     {
//       value: 'Placing bet',
//       class: 'h2',
//     },
//     {
//       value: `1. Select bet chip`,
//     },
//     {
//       value: `2. Place chip by clicking on preferred bet selection`,
//     },
//     {
//       value: `3. Click  <span class="bold"> Bet </span>  button to confirm your bet`,
//     },
//     {
//       value: `game-help/en.webp`,
//       type: 'image',
//     },
//     {
//       value: 'FAIR GAME RULES',
//       class: 'h1',
//     },
//     {
//       value: 'Live streaming',
//       class: 'h2',
//     },
//     {
//       value: `Unforeseen issues such as internet connectivity, power supply, or weather disruptions
//                 caused the live stream to be interrupted before the fight began. If the fight is not displayed
//                  on the game site, all bets will be refunded`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'Arena management decision',
//       class: 'h2',
//     },
//     {
//       value: `Arena management reserves the right to cancel any match; announcements
//                 regarding arena decisions will be made on a case-by-case basis. <br />
//                 1. The match began, but Arena Management determined that cock was injured.
//                 Arena management has the right to cancel the fight if neither cock has a cut or bleed. <br />
//                 2. Any other unforeseeable events.
//                 `,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'Bet not closed in time',
//       class: 'h2',
//     },
//     {
//       value: `Bets placed after the fight began will be void and refunded to members
//                 due to unforeseen technical issues.`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'T&C',
//       class: 'm-r-8',
//     },
//     {
//       value: `<a href="#">Terms & Conditions</a>`,
//       class: 'inline-right',
//       type: 'link',
//       link: 'tnc',
//     },
//   ],
//   vn: [
//     {
//       value: 'Luật đá gà',
//       class: 'h1',
//     },
//     {
//       value: '<span class="badge bg-red p-8 br-4">Đỏ</span>',
//       class: '',
//     },
//     {
//       value: `Gà <span class="text-red">Đỏ</span> sẽ bắt đầu đi vào từ luồng bên trái.`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-blue p-8 br-4">Xanh</span>',
//       class: '',
//     },
//     {
//       value: `Gà <span class="text-blue">Xanh</span> sẽ bắt đầu đi vào từ luồng bên phải.
//       `,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-green p-8 br-4">Draw</span>',
//       class: '',
//     },
//     {
//       value: `Nếu không có gà trống nào Mổ thành công hai lần theo Quy trình Carreo (hệ thống 3 lên & 3 xuống)
//       hoặc nếu không có chiến kê nào được công bố sau mười (10) phút kể từ lần chạm đầu tiên,
//       sẽ không có gà trống nào được công bố là người chiến thắng.
//                 `,
//       class: 'inline ',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'HƯỚNG DẪN CƯỢC',
//       class: 'h1',
//     },
//     {
//       value: 'Đặt cược',
//       class: 'h2',
//     },
//     {
//       value: `1. Chọn chip đặt cược`,
//     },
//     {
//       value: `2. Đặt chip bằng cách nhấp vào lựa chọn cược ưa thích`,
//     },
//     {
//       value: `3. Nhấp nút <span class="bold"> Cược </span> để xác nhận đặt cược của bạn`,
//     },
//     {
//       value: `game-help/vn.webp`,
//       type: 'image',
//     },
//     {
//       value: 'Luật chơi công bằng',
//       class: 'h1',
//     },
//     {
//       value: 'Live streaming',
//       class: 'h2',
//     },
//     {
//       value: `Những sự cố không lường trước được như kết nối internet, nguồn điện hay thời tiết gián
//       đoạn đã khiến buổi phát trực tiếp bị gián đoạn trước khi trận đấu bắt đầu. Nếu trận đấu
//       không được hiển thị trên trang web trò chơi, tất cả cược sẽ được hoàn trả.`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'Quyết định quản lý đấu trường',
//       class: 'h2',
//     },
//     {
//       value: `Ban quản lý đấu trường có quyền hủy bất kỳ trận đấu nào; thông báo liên quan đến các quyết
//       định của đấu trường sẽ được đưa ra tùy theo từng trường hợp cụ thể. <br />
//                 1. Trận đấu bắt đầu nhưng Ban quản lý Đấu trường xác định gà bị thương. Ban quản lý đấu
//                 trường có quyền hủy trận đấu nếu cả hai trống đều có vết thương hoặc chảy máu. <br />
//                 2. Bất kỳ sự kiện không lường trước được khác.
//                 `,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'Cược không được đóng đúng thời gian',
//       class: 'h2',
//     },
//     {
//       value: `Các cược được đặt sau khi trận đấu bắt đầu sẽ vô hiệu và được hoàn trả cho các
//       thành viên do các vấn đề kỹ thuật không lường trước được.`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'Điều khoản và Điều kiện',
//       class: 'm-r-8',
//     },
//     {
//       value: `<a href="#">Điều khoản và điều kiện</a>`,
//       class: 'inline-right',
//       type: 'link',
//       link: 'tnc',
//     },
//   ],
//   th: [
//     {
//       value: 'ความท้าทายในการชนไก่',
//       class: 'h1',
//     },
//     {
//       value: '<span class="badge bg-red p-8 br-4">Banker</span>',
//       class: '',
//     },
//     {
//       value: `ที่ <span class="text-red">Banker</span> ไก่โต้งเริ่มต้นที่ซ้าย ด้านข้างของการถ่ายทอดสด`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-blue p-8 br-4">Player</span>',
//       class: '',
//     },
//     {
//       value: `ที่ <span class="text-blue">Player</span> ไก่โต้งเริ่มต้นที่ขวา ด้านข้างของการถ่ายทอดสด`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-green p-8 br-4">Draw</span>',
//       class: '',
//     },
//     {
//       value: `หากไม่มีไก่ตัวใดจิกได้สำเร็จสองครั้งในระหว่างขั้นตอนคาร์เรโอ (ระบบ 3 ขึ้นและ 3 ลง)
//                 หรือหากไม่มีการประกาศผู้ชนะหลังจากสิบ (10) นาทีนับจากการสัมผัสครั้งแรก จะไม่มีการประกาศผู้ชนะ`,
//       class: 'inline ',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'คู่มือการเดิมพัน',
//       class: 'h1',
//     },
//     {
//       value: 'การวางเดิมพัน',
//       class: 'h2',
//     },
//     {
//       value: `1. เลือกชิปเดิมพัน`,
//     },
//     {
//       value: `2. วางชิปโดยคลิกที่ตัวเลือกเดิมพันที่ต้องการ`,
//     },
//     {
//       value: `3. คลิกแต่ปุ่มเพื่อยืนยันการเดิมพันของคุณ`,
//     },
//     {
//       value: `game-help/th.webp`,
//       type: 'image',
//     },
//     {
//       value: 'กฎของเกมที่ยุติธรรม',
//       class: 'h1',
//     },
//     {
//       value: 'ถ่ายทอดสด',
//       class: 'h2',
//     },
//     {
//       value: `ปัญหาที่ไม่คาดคิด เช่น การเชื่อมต่ออินเทอร์เน็ต ไฟฟ้า หรือการหยุดชะงักของสภาพอากาศ
//                 ทำให้การสตรีมสดหยุดชะงักก่อนการต่อสู้จะเริ่มขึ้น หากการต่อสู้ไม่แสดงบนเว็บไซต์เกม
//                 การเดิมพันทั้งหมดจะได้รับการคืนเงิน`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'การตัดสินใจการจัดการอารีน่า',
//       class: 'h2',
//     },
//     {
//       value: `ฝ่ายจัดการอารีน่าขอสงวนสิทธิ์ในการยกเลิกการแข่งขันใดๆ
//                 ประกาศเกี่ยวกับการตัดสินใจของอารีน่าจะพิจารณาเป็นรายกรณี <br />
//                 1.การแข่งขันเริ่มต้นขึ้น แต่ Arena Management ระบุว่าไก่ได้รับบาดเจ็บ
//                 ฝ่ายจัดการอารีน่ามีสิทธิ์ยกเลิกการต่อสู้ได้ หากไม่มีไก่ตัวใดถูกตัดหรือมีเลือดออก <br />
//                 2. เหตุการณ์ที่ไม่คาดฝันอื่น ๆ
//                 `,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'เดิมพันปิดไม่ทัน',
//       class: 'h2',
//     },
//     {
//       value: `เดิมพันที่วางหลังจากการต่อสู้เริ่มขึ้นจะถือเป็นโมฆะและคืนเ
//                 งินให้กับสมาชิกเนื่องจากปัญหาทางเทคนิคที่คาดไม่ถึง`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'ข้อกำหนดและเงื่อนไข',
//       class: 'm-r-8',
//     },
//     {
//       value: `<a href="#">ข้อตกลงและเงื่อนไข</a>`,
//       class: 'inline-right',
//       type: 'link',
//       link: 'tnc',
//     },
//   ],
//   id: [
//     {
//       value: 'TANTANGAN SAMBUNGAN AYAM',
//       class: 'h1',
//     },
//     {
//       value: '<span class="badge bg-red p-8 br-4">Banker</span>',
//       class: '',
//     },
//     {
//       value: `Itu <span class="text-red">Banker</span> ayam jantan mulai pada
//                 <span class="bold"> Kiri </span> sisi streaming langsung.`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-blue p-8 br-4">Player</span>',
//       class: '',
//     },
//     {
//       value: `Itu <span class="text-blue">Player</span> ayam jantan mulai pada
//                 <span class="bold">Benar</span> sisi streaming langsung.`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-green p-8 br-4">Draw</span>',
//       class: '',
//     },
//     {
//       value: `Jika tidak ada ayam jago yang berhasil mematuk dua kali selama Prosedur Carreo
//                 (sistem 3 naik & 3 turun) atau jika tidak ada pemenang yang diumumkan setelah sepuluh
//                 (10) menit sejak kontak pertama, tidak akan ada pemenang yang diumumkan.`,
//       class: 'inline ',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'PANDUAN TARUHAN',
//       class: 'h1',
//     },
//     {
//       value: 'Memasang taruhan',
//       class: 'h2',
//     },
//     {
//       value: `1. Pilih chip taruhan`,
//     },
//     {
//       value: `2. Tempatkan chip dengan mengklik pilihan taruhan yang diinginkan`,
//     },
//     {
//       value: `3. Klik  <span class="bold"> Taruhan </span>  tombol untuk mengkonfirmasi taruhan Anda`,
//     },
//     {
//       value: `game-help/id.webp`,
//       type: 'image',
//     },
//     {
//       value: 'Aturan Permainan yang Adil',
//       class: 'h1',
//     },
//     {
//       value: 'Streaming Langsung',
//       class: 'h2',
//     },
//     {
//       value: `Masalah tak terduga seperti konektivitas internet, pasokan listrik,
//                 atau gangguan cuaca menyebabkan siaran langsung terhenti sebelum pertarungan dimulai.
//                 Jika pertarungan tidak ditampilkan di situs permainan, semua taruhan akan dikembalikan.`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'Keputusan Manajemen Arena',
//       class: 'h2',
//     },
//     {
//       value: `Manajemen arena berhak membatalkan pertandingan apapun; pengumuman mengenai
//                 keputusan arena akan dibuat berdasarkan kasus per kasus. <br />
//                 1. Pertandingan dimulai, tetapi Manajemen Arena menetapkan bahwa ayam tersebut terluka.
//                 Manajemen arena berhak membatalkan pertarungan jika tidak ada ayam yang terpotong atau berdarah.
//                 <br />
//                 2. Kejadian-kejadian lain yang tidak terduga.
//                 `,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'Taruhan tidak ditutup tepat waktu',
//       class: 'h2',
//     },
//     {
//       value: `Taruhan yang dipasang setelah pertarungan dimulai akan dibatalkan dan dikembalikan
//                 kepada anggota karena masalah teknis yang tidak terduga.`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'S&K',
//       class: 'm-r-8',
//     },
//     {
//       value: `<a href="#">Syarat & Ketentuan</a>`,
//       class: 'inline-right',
//       type: 'link',
//       link: 'tnc',
//     },
//   ],
//   zh: [
//     {
//       value: '斗鸡挑战赛',
//       class: 'h1',
//     },
//     {
//       value: '<span class="badge bg-red p-8 br-4">庄家</span>',
//       class: '',
//     },
//     {
//       value: `<span class="text-red">庄家</span>的斗鸡从直播的
//                 <span class="bold">左侧</span>开始。`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-blue p-8 br-4">闲家</span>',
//       class: '',
//     },
//     {
//       value: `<span class="text-blue">闲家</span>的斗鸡从直播的
//                 <span class="bold">右侧</span>开始。`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-green p-8 br-4">平局</span>',
//       class: '',
//     },
//     {
//       value: `如果在Carreo程序（3上3下系统）期间，没有任何一只鸡成功啄击两次，或者从首次接触开始十（10）分钟后没有宣布胜者，那么将不会有胜者被宣布。`,
//       class: 'inline ',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '投注指南',
//       class: 'h1',
//     },
//     {
//       value: '下注方法',
//       class: 'h2',
//     },
//     {
//       value: `1. 选择下注筹码`,
//     },
//     {
//       value: `2. 通过点击所选的下注选项来放置筹码`,
//     },
//     {
//       value: `3. 点击“<span class="bold">下注</span>”按钮确认您的下注`,
//     },
//     {
//       value: `game-help/en.webp`,
//       type: 'image',
//     },
//     {
//       value: '公平游戏规则',
//       class: 'h1',
//     },
//     {
//       value: '直播',
//       class: 'h2',
//     },
//     {
//       value: `由于互联网连接、电源供应或天气干扰等不可预见的问题导致直播在战斗开始前被中断。如果游戏网站上未显示战斗，所有下注将被退款。`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '擂台管理决定',
//       class: 'h2',
//     },
//     {
//       value: `擂台管理有权取消任何比赛；关于擂台决策的公告将根据具体情况进行。
//       <br />
//                 1. 比赛开始了，但擂台管理确定斗鸡受伤。如果两只斗鸡都没有割伤或流血，擂台管理有权取消战斗。 <br />
//                 2. 任何其他不可预见的事件。
//                 `,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '下注未及时关闭',
//       class: 'h2',
//     },
//     {
//       value: `由于不可预见的技术问题，战斗开始后下的注将被视为无效并退还给会员。`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: `<a href="#">条款与条件</a>`,
//       class: 'inline-right',
//       type: 'link',
//       link: 'tnc',
//     },
//   ],
//   kr: [
//     { value: '닭싸움 챌린지', class: 'h1' },
//     { value: '<span class="badge bg-red p-8 br-4">뱅커</span>', class: '' },
//     {
//       value: `<span class="text-red">뱅커</span> 수탉은 생중계 화면의
//             <span class="bold">왼쪽</span>에서 시작합니다.`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: '<span class="badge bg-blue p-8 br-4">플레이어</span>', class: '' },
//     {
//       value: `<span class="text-blue">플레이어</span> 수탉은 생중계 화면의
//             <span class="bold">오른쪽</span>에서 시작합니다.`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: '<span class="badge bg-green p-8 br-4">무승부</span>', class: '' },
//     {
//       value: `Carreo 절차(3업 & 3다운 시스템) 중 두 번 쪼는 데 성공한 수탉이 없거나
//             최초 접촉 후 10분 이내에 승자가 결정되지 않으면, 무승부로 간주되어
//             승자는 없습니다.`,
//       class: 'inline ',
//     },
//     { value: '<br />', class: 'break' },
//     { value: '베팅 가이드', class: 'h1' },
//     { value: '베팅 방법', class: 'h2' },
//     { value: `1. 베팅 칩 선택` },
//     { value: `2. 원하는 항목에 칩을 클릭하여 베팅` },
//     { value: `3. <span class="bold">베팅</span> 버튼을 클릭하여 베팅 확인` },
//     { value: `game-help/en.webp`, type: 'image' },
//     { value: '공정한 게임 규칙', class: 'h1' },
//     { value: '라이브 스트리밍', class: 'h2' },
//     {
//       value: `인터넷, 전력, 날씨 등의 예기치 못한 문제로 경기 시작 전에 생중계가 중단될 경우,
//             게임 화면에 경기가 표시되지 않으면 모든 베팅은 환불됩니다.`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: '경기장 운영 결정', class: 'h2' },
//     {
//       value: `경기장 운영진은 어떤 경기든 취소할 수 있는 권리를 보유합니다.
//             해당 결정은 개별적으로 공지됩니다. <br />
//             1. 경기가 시작되었지만 수탉이 부상당한 것으로 판단된 경우.
//             수탉 중 어느 쪽도 출혈이나 상처가 없을 경우 경기장 운영진은
//             경기를 취소할 권한이 있습니다. <br />
//             2. 기타 예기치 못한 상황.`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: '베팅 마감 시간 초과', class: 'h2' },
//     {
//       value: `경기 시작 후에 이루어진 베팅은 무효 처리되며,
//             기술적 문제로 인해 환불됩니다.`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: '약관', class: 'm-r-8' },
//     {
//       value: `<a href="#">이용약관</a>`,
//       class: 'inline-right',
//       type: 'link',
//       link: 'tnc',
//     },
//   ],
//   jp: [
//     { value: '闘鶏チャレンジ', class: 'h1' },
//     { value: '<span class="badge bg-red p-8 br-4">バンカー</span>', class: '' },
//     {
//       value: `<span class="text-red">バンカー</span>の鶏はライブ配信画面の
//             <span class="bold">左側</span>からスタートします。`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: '<span class="badge bg-blue p-8 br-4">プレイヤー</span>', class: '' },
//     {
//       value: `<span class="text-blue">プレイヤー</span>の鶏はライブ配信画面の
//             <span class="bold">右側</span>からスタートします。`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: '<span class="badge bg-green p-8 br-4">引き分け</span>', class: '' },
//     {
//       value: `Carreo手順（3アップ＆3ダウン方式）中にどちらの鶏も2回のつつきに成功しなかった場合、
//             または最初の接触から10分以内に勝者が決まらない場合、勝者なしとされます。`,
//       class: 'inline ',
//     },
//     { value: '<br />', class: 'break' },
//     { value: 'ベットガイド', class: 'h1' },
//     { value: 'ベットの方法', class: 'h2' },
//     { value: `1. ベットチップを選択` },
//     { value: `2. 選択したベット項目にチップをクリック` },
//     { value: `3. <span class="bold">ベット</span> ボタンをクリックして確認` },
//     { value: `game-help/en.webp`, type: 'image' },
//     { value: '公正なゲームルール', class: 'h1' },
//     { value: 'ライブ配信', class: 'h2' },
//     {
//       value: `インターネット接続、電源、天候などの予期せぬ問題により試合開始前にライブ配信が中断された場合、
//             ゲーム画面に試合が表示されなければ、すべてのベットは返金されます。`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: 'アリーナの判断', class: 'h2' },
//     {
//       value: `アリーナ運営は、試合をキャンセルする権利を有します。
//             決定に関するお知らせは個別に行われます。<br />
//             1. 試合は始まったが、鶏が負傷していると判断された場合。
//             双方に切り傷や出血がない場合、試合をキャンセルする権利があります。<br />
//             2. その他の予期せぬ事象。`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: 'ベット締切遅延', class: 'h2' },
//     {
//       value: `技術的な問題により、試合開始後に行われたベットは無効となり、
//             会員へ返金されます。`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: '利用規約', class: 'm-r-8' },
//     {
//       value: `<a href="#">利用規約</a>`,
//       class: 'inline-right',
//       type: 'link',
//       link: 'tnc',
//     },
//   ],
//   es: [
//     { value: 'DESAFÍO DE PELEA DE GALLOS', class: 'h1' },
//     { value: '<span class="badge bg-red p-8 br-4">Banquero</span>', class: '' },
//     {
//       value: `Los gallos del <span class="text-red">Banquero</span> comienzan en el
//             <span class="bold">lado izquierdo</span> de la transmisión en vivo.`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: '<span class="badge bg-blue p-8 br-4">Jugador</span>', class: '' },
//     {
//       value: `Los gallos del <span class="text-blue">Jugador</span> comienzan en el
//             <span class="bold">lado derecho</span> de la transmisión en vivo.`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: '<span class="badge bg-green p-8 br-4">Empate</span>', class: '' },
//     {
//       value: `Si ninguno de los gallos logra picar dos veces durante
//             el Procedimiento Carreo (sistema de 3 arriba y 3 abajo),
//             o si no se declara un ganador después de diez (10) minutos desde el primer contacto,
//             no habrá ganador declarado.`,
//       class: 'inline ',
//     },
//     { value: '<br />', class: 'break' },
//     { value: 'GUÍA DE APUESTAS', class: 'h1' },
//     { value: 'Cómo apostar', class: 'h2' },
//     { value: `1. Selecciona una ficha de apuesta` },
//     { value: `2. Coloca la ficha haciendo clic en tu selección preferida` },
//     { value: `3. Haz clic en el botón <span class="bold">Apostar</span> para confirmar tu apuesta` },
//     { value: `game-help/en.webp`, type: 'image' },
//     { value: 'REGLAS DEL JUEGO JUSTO', class: 'h1' },
//     { value: 'Transmisión en vivo', class: 'h2' },
//     {
//       value: `Problemas imprevistos como conexión a internet, suministro eléctrico o clima pueden
//             interrumpir la transmisión antes de que comience la pelea. Si la pelea no se muestra
//             en el sitio del juego, todas las apuestas serán reembolsadas.`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: 'Decisiones del administrador de la arena', class: 'h2' },
//     {
//       value: `La administración de la arena se reserva el derecho de cancelar cualquier combate;
//             los anuncios se harán caso por caso. <br />
//             1. Si el combate comenzó pero se determina que un gallo está herido,
//             se puede cancelar si ninguno sangra o tiene una herida. <br />
//             2. Cualquier otro evento imprevisto.`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: 'Apuesta no cerrada a tiempo', class: 'h2' },
//     {
//       value: `Las apuestas realizadas después de que comience la pelea se anularán
//             y se reembolsarán a los miembros por problemas técnicos imprevistos.`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: 'Términos y Condiciones', class: 'm-r-8' },
//     {
//       value: `<a href="#">Términos y Condiciones</a>`,
//       class: 'inline-right',
//       type: 'link',
//       link: 'tnc',
//     },
//   ],
//   pk: [
//     { value: 'مرغ بازی چیلنج', class: 'h1' },
//     { value: '<span class="badge bg-red p-8 br-4">بینکر</span>', class: '' },
//     {
//       value: `<span class="text-red">بینکر</span> مرغے لائیو اسٹریم کے
//             <span class="bold">بائیں طرف</span> سے شروع ہوتے ہیں۔`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: '<span class="badge bg-blue p-8 br-4">پلیئر</span>', class: '' },
//     {
//       value: `<span class="text-blue">پلیئر</span> مرغے لائیو اسٹریم کے
//             <span class="bold">دائیں طرف</span> سے شروع ہوتے ہیں۔`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: '<span class="badge bg-green p-8 br-4">برابری</span>', class: '' },
//     {
//       value: `اگر کوئی بھی مرغا Carreo طریقہ کار (3 اوپر اور 3 نیچے) میں
//             دو بار چونچ مارنے میں کامیاب نہ ہو یا پہلے رابطے کے دس (10) منٹ بعد بھی
//             کوئی فاتح نہ ہو تو کوئی فاتح قرار نہیں دیا جائے گا۔`,
//       class: 'inline ',
//     },
//     { value: '<br />', class: 'break' },
//     { value: 'بیٹنگ گائیڈ', class: 'h1' },
//     { value: 'بیٹنگ کرنے کا طریقہ', class: 'h2' },
//     { value: `1. شرط کا چپ منتخب کریں` },
//     { value: `2. اپنی پسند کے آپشن پر کلک کر کے چپ رکھیں` },
//     { value: `3. <span class="bold">بیٹ</span> بٹن پر کلک کر کے تصدیق کریں` },
//     { value: `game-help/en.webp`, type: 'image' },
//     { value: 'منصفانہ کھیل کے اصول', class: 'h1' },
//     { value: 'لائیو اسٹریمنگ', class: 'h2' },
//     {
//       value: `اگر انٹرنیٹ، بجلی یا موسم کی وجہ سے لائیو اسٹریم لڑائی سے پہلے رک جائے
//             اور گیم سائٹ پر دکھائی نہ دے تو تمام شرطیں واپس کر دی جائیں گی۔`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: 'ارینا کا فیصلہ', class: 'h2' },
//     {
//       value: `ارینا مینجمنٹ کسی بھی مقابلے کو منسوخ کرنے کا حق رکھتی ہے؛
//             اعلانات انفرادی بنیاد پر کیے جائیں گے۔ <br />
//             1. اگر مقابلہ شروع ہو چکا ہو لیکن مرغے کو زخمی قرار دیا جائے
//             اور کسی کو چوٹ یا خون نہ آیا ہو، تو مقابلہ منسوخ کیا جا سکتا ہے۔ <br />
//             2. کوئی بھی اور غیر متوقع صورتحال۔`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: 'شرط وقت پر بند نہ ہو', class: 'h2' },
//     {
//       value: `اگر لڑائی شروع ہونے کے بعد شرط لگائی گئی ہو تو وہ باطل ہوگی
//             اور تکنیکی مسائل کی وجہ سے رقم واپس کر دی جائے گی۔`,
//       class: 'inline-right',
//     },
//     { value: '<br />', class: 'break' },
//     { value: 'شرائط و ضوابط', class: 'm-r-8' },
//     {
//       value: `<a href="#">شرائط و ضوابط</a>`,
//       class: 'inline-right',
//       type: 'link',
//       link: 'tnc',
//     },
//   ],
//   mm: [
//     {
//       value: '1. ကြက်တိုက်ခြင်းစိန်ခေါ်မှု',
//       class: 'h1',
//     },
//     {
//       value: '<span class="badge bg-red p-8 br-4">ဒိုင်</span>',
//       class: '',
//     },
//     {
//       value: `ဟိ <span class="text-red">ဒိုင်</span> ကြက်ဖများ မှ စတင်သည်။
//                 <span class="bold"> ဝဲ </span> တိုက်ရိုက်ထုတ်လွှင့်မှု၏ဘက်ခြမ်း။`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-blue p-8 br-4">ဘာညာ</span>',
//       class: '',
//     },
//     {
//       value: `ဟိ <span class="text-blue">ဘာညာ</span> ကြက်ဖများ မှ စတင်သည်။
//                 <span class="bold">မှန်တယ်။</span> တိုက်ရိုက်ထုတ်လွှင့်မှု၏ဘက်ခြမ်း။`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-green p-8 br-4">ဆွဲသည်။</span>',
//       class: '',
//     },
//     {
//       value: `Carreo Procedure (3 up & 3 down system) အတွင်း ကြက်နှစ်ကောင်က အောင်မြင်စွာ ကိုက်ခြင်းမရှိပါက သို့မဟုတ် ပထမအဆက်အသွယ်မှ ဆယ်မိနစ် (10)မိနစ်ကြာပြီးနောက်တွင် အနိုင်ရရှိသူကို ကြေညာမည်မဟုတ်ပါ။`,
//       class: 'inline ',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '2. လောင်းကစားလမ်းညွှန်',
//       class: 'h1',
//     },
//     {
//       value: 'လောင်းကြေးထပ်တယ်။',
//       class: 'h2',
//     },
//     {
//       value: `1. အလောင်းအစားချစ်ပ်ကို ရွေးပါ။`,
//     },
//     {
//       value: `2. နှစ်သက်ရာ လောင်းကြေးရွေးချယ်မှုကို နှိပ်ခြင်းဖြင့် ချစ်ပ်ပြားကို နေရာချပါ။`,
//     },
//     {
//       value: `3. နှိပ်ပါ။  <span class="bold"> ဒါပေမယ့် </span>  သင်၏အလောင်းအစားကိုအတည်ပြုရန်ခလုတ်`,
//     },
//     {
//       value: `game-help/en.webp`,
//       type: 'image',
//     },
//     {
//       value: '3. တရားမျှတသောဂိမ်းစည်းမျဉ်းများ',
//       class: 'h1',
//     },
//     {
//       value: 'တိုက်ရိုက်လွှင့်',
//       class: 'h2',
//     },
//     {
//       value: `အင်တာနက်ချိတ်ဆက်မှု၊ ပါဝါထောက်ပံ့မှု သို့မဟုတ် ရာသီဥတု အနှောင့်အယှက်များကဲ့သို့သော ကြိုမြင်ထားသည့်ပြဿနာများသည် တိုက်ပွဲမစတင်မီ တိုက်ရိုက်ထုတ်လွှင့်မှုကို အနှောင့်အယှက်ဖြစ်စေသည်။ ဂိမ်းဆိုက်တွင် တိုက်ပွဲကို မပြသပါက လောင်းကြေးအားလုံးကို ပြန်အမ်းပါမည်။`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'Arena စီမံခန့်ခွဲမှု ဆုံးဖြတ်ချက်',
//       class: 'h2',
//     },
//     {
//       value: `Arena စီမံခန့်ခွဲမှုသည် မည်သည့်ပွဲစဉ်ကိုမဆို ပယ်ဖျက်ပိုင်ခွင့်ရှိသည်။ အားကစားကွင်း ဆုံးဖြတ်ချက်များနှင့် စပ်လျဉ်းသည့် ကြေညာချက်များကို ကိစ္စရပ်တစ်ခုချင်းအလိုက် ထုတ်ပြန်မည်ဖြစ်သည်။ <br />
//                 1. ပွဲစတင်ခဲ့ပေမယ့် Arena Management က ကြက်ဒဏ်ရာရခဲ့တယ်လို့ ဆုံးဖြတ်ခဲ့ပါတယ်။ ကြက်နှစ်ကောင်တွင် ပြတ်ရှ သို့မဟုတ် သွေးထွက်ခြင်းမရှိပါက Arena စီမံခန့်ခွဲမှုတွင် တိုက်ပွဲကို ပယ်ဖျက်ပိုင်ခွင့်ရှိသည်။ <br />
//                 2. အခြားသော မထင်မှတ်ထားသော အဖြစ်အပျက်များ။
//                 `,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'လောင်းကြေးအချိန်မီမပိတ်ပါ။',
//       class: 'h2',
//     },
//     {
//       value: `တိုက်ပွဲစတင်ပြီးနောက် လောင်းကြေးများ ပျက်ပြယ်သွားမည်ဖြစ်ပြီး မထင်မှတ်ထားသော နည်းပညာဆိုင်ရာ ပြဿနာများကြောင့် အဖွဲ့ဝင်များထံ ပြန်အမ်းမည်ဖြစ်သည်။`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'T&C',
//       class: 'm-r-8',
//     },
//     {
//       value: `<a href="#">စည်းကမ်းသတ်မှတ်ချက်များ</a>`,
//       class: 'inline-right',
//       type: 'link',
//       link: 'tnc',
//     },
//   ],
//   bd: [
//     {
//       value: '১. ককফাইটিং চ্যালেঞ্জ',
//       class: 'h1',
//     },
//     {
//       value: '<span class="badge bg-red p-8 br-4">ব্যাংকার</span>',
//       class: '',
//     },
//     {
//       value: `দ্য<span class="text-red">ব্যাংকার</span> মোরগগুলো শুরু হয়বামলাইভ স্ট্রিমের পাশে।`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-blue p-8 br-4">খেলোয়াড়</span>',
//       class: '',
//     },
//     {
//       value: `দ্য<span class="text-blue">খেলোয়াড়</span> মোরগগুলো শুরু হয়ঠিকলাইভ স্ট্রিমের পাশে।`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-green p-8 br-4">আঁকা</span>',
//       class: '',
//     },
//     {
//       value: `ক্যারিও পদ্ধতিতে (৩টি উপরে এবং ৩টি নীচে) যদি কোন মোরগ সফলভাবে দুবার খোঁচা না দেয় অথবা প্রথম যোগাযোগের দশ (১০) মিনিট পরে যদি কোন বিজয়ী ঘোষণা না করা হয়, তাহলে কোন ঘোষিত বিজয়ী থাকবে না।`,
//       class: 'inline ',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '2. বাজি ধরার নির্দেশিকা',
//       class: 'h1',
//     },
//     {
//       value: 'বাজি ধরা',
//       class: 'h2',
//     },
//     {
//       value: `1. বেট চিপ নির্বাচন করুন`,
//     },
//     {
//       value: `2. পছন্দের বাজি নির্বাচনের উপর ক্লিক করে চিপ রাখুন`,
//     },
//     {
//       value: `3. ক্লিক করুনকি<span class="bold">ন্তু</span>আপনার বাজি নিশ্চিত করার জন্য বোতাম`,
//     },
//     {
//       value: `game-help/en.webp`,
//       type: 'image',
//     },
//     {
//       value: '৩. ন্যায্য খেলার নিয়ম',
//       class: 'h1',
//     },
//     {
//       value: 'সরাসরি সম্প্রচার',
//       class: 'h2',
//     },
//     {
//       value: `ইন্টারনেট সংযোগ, বিদ্যুৎ সরবরাহ, অথবা আবহাওয়ার বিঘ্নের মতো অপ্রত্যাশিত সমস্যার কারণে লড়াই শুরু হওয়ার আগেই লাইভ স্ট্রিম ব্যাহত হয়। যদি লড়াইটি খেলার সাইটে প্রদর্শিত না হয়, তাহলে সমস্ত বাজি ফেরত দেওয়া হবে।`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'এরিনা ব্যবস্থাপনার সিদ্ধান্ত',
//       class: 'h2',
//     },
//     {
//       value: `এরিনা কর্তৃপক্ষ যেকোনো ম্যাচ বাতিল করার অধিকার সংরক্ষণ করে; প্রতিটি ম্যাচের ভিত্তিতে এরিনার সিদ্ধান্ত ঘোষণা করা হবে। <br />
//                 1. খেলা শুরু হয়েছিল, কিন্তু এরিনা ম্যানেজমেন্ট সিদ্ধান্ত নেয় যে মোরগটি আহত। যদি কোনও মোরগেরই কাটা না থাকে বা রক্তপাত না হয়, তাহলে এরিনা ম্যানেজমেন্টের লড়াই বাতিল করার অধিকার রয়েছে। <br />
//                 2. অন্য কোন অপ্রত্যাশিত ঘটনা।
//                 `,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'সময়মতো বাজি বন্ধ হয়নি',
//       class: 'h2',
//     },
//     {
//       value: `লড়াই শুরু হওয়ার পরে লাগানো বাজি বাতিল করা হবে এবং অপ্রত্যাশিত প্রযুক্তিগত সমস্যার কারণে সদস্যদের ফেরত দেওয়া হবে।`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'শর্তাবলী',
//       class: 'm-r-8',
//     },
//     {
//       value: `<a href="#">শর্তাবলী</a>`,
//       class: 'inline-right',
//       type: 'link',
//       link: 'tnc',
//     },
//   ],
//   in: [
//     {
//       value: 'मुर्गा लड़ाई चुनौती',
//       class: 'h1',
//     },
//     {
//       value: '<span class="badge bg-red p-8 br-4">बैंकर</span>',
//       class: '',
//     },
//     {
//       value: `द<span class="text-red">बैंकर</span> मुर्गे शुरू होते हैं
//                 <span class="bold">बाएं</span>लाइव स्ट्रीम के किनारे.`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-blue p-8 br-4">खिलाड़ी</span>',
//       class: '',
//     },
//     {
//       value: `द<span class="text-blue">खिलाड़ी</span>मुर्गे शुरू होते हैं
//                 <span class="bold">सही</span>लाइव स्ट्रीम के किनारे.`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-green p-8 br-4">खींचना</span>',
//       class: '',
//     },
//     {
//       value: `यदि कोई भी मुर्गा कैरेओ प्रक्रिया (3 अप और 3 डाउन प्रणाली) के दौरान दो बार सफलतापूर्वक चोंच नहीं मारता है या यदि पहले संपर्क से दस (10) मिनट के बाद कोई विजेता घोषित नहीं किया जाता है, तो कोई घोषित विजेता नहीं होगा।`,
//       class: 'inline ',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'सट्टेबाजी गाइड',
//       class: 'h1',
//     },
//     {
//       value: 'दांव लगाना',
//       class: 'h2',
//     },
//     {
//       value: `1. बेट चिप चुनें`,
//     },
//     {
//       value: `2. पसंदीदा दांव चयन पर क्लिक करके चिप लगाएं`,
//     },
//     {
//       value: `3. क्लिक करें  <span class="bold"> लेकिन </span> अपनी शर्त की पुष्टि करने के लिए बटन`,
//     },
//     {
//       value: `game-help/en.webp`,
//       type: 'image',
//     },
//     {
//       value: 'निष्पक्ष खेल नियम',
//       class: 'h1',
//     },
//     {
//       value: 'सीधा आ रहा है',
//       class: 'h2',
//     },
//     {
//       value: `इंटरनेट कनेक्टिविटी, बिजली आपूर्ति या मौसम संबंधी व्यवधान जैसी अप्रत्याशित समस्याओं के कारण मुकाबला शुरू होने से पहले ही लाइव स्ट्रीम बाधित हो गई। अगर मुकाबला खेल साइट पर प्रदर्शित नहीं होता है, तो सभी दांव वापस कर दिए जाएँगे।`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'अखाड़ा प्रबंधन निर्णय',
//       class: 'h2',
//     },
//     {
//       value: `एरेना प्रबंधन किसी भी मैच को रद्द करने का अधिकार सुरक्षित रखता है; एरेना के निर्णयों की घोषणा मामले-दर-मामला आधार पर की जाएगी। <br />
//                 1. मैच शुरू हुआ, लेकिन एरिना प्रबंधन ने पाया कि कॉक घायल है। अगर किसी भी कॉक को कोई कट या खून नहीं निकला है, तो एरिना प्रबंधन को मुकाबला रद्द करने का अधिकार है। <br />
//                 2. कोई अन्य अप्रत्याशित घटना.
//                 `,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'शर्त समय पर बंद नहीं हुई',
//       class: 'h2',
//     },
//     {
//       value: `Bअप्रत्याशित तकनीकी समस्याओं के कारण लड़ाई शुरू होने के बाद लगाए गए दांव अमान्य हो जाएंगे तथा सदस्यों को वापस कर दिए जाएंगे।`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: 'नियम और शर्तें',
//       class: 'm-r-8',
//     },
//     {
//       value: `<a href="#">नियम एवं शर्तें</a>`,
//       class: 'inline-right',
//       type: 'link',
//       link: 'tnc',
//     },
//   ],
//   hant: [
//     {
//       value: '鬥雞挑戰賽',
//       class: 'h1',
//     },
//     {
//       value: '<span class="badge bg-red p-8 br-4">莊家</span>',
//       class: '',
//     },
//     {
//       value: ` <span class="text-red">莊家</span> 的鬥雞從直播的
//                 <span class="bold">左側</span> 開始。`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-blue p-8 br-4">玩家</span>',
//       class: '',
//     },
//     {
//       value: ` <span class="text-blue">玩家</span> 的鬥雞從直播的
//                 <span class="bold">右側</span> 開始。`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '<span class="badge bg-green p-8 br-4">平手</span>',
//       class: '',
//     },
//     {
//       value: `若在 Carreo 程序（3 上 3 下 系統）期間，沒有任何一隻鬥雞成功啄擊兩次，
//                 或者從首次接觸開始起十（10）分鐘後仍未能判定勝負，則視為無勝者。`,
//       class: 'inline ',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '投注指南',
//       class: 'h1',
//     },
//     {
//       value: '下注方法',
//       class: 'h2',
//     },
//     {
//       value: `1. 選擇下注籌碼`,
//     },
//     {
//       value: `2. 點擊偏好的下注選項來放置籌碼`,
//     },
//     {
//       value: `3. 點擊 <span class="bold">下注</span> 按鈕確認您的下注`,
//     },
//     {
//       value: `game-help/en.webp`,
//       type: 'image',
//     },
//     {
//       value: '公平遊戲規則',
//       class: 'h1',
//     },
//     {
//       value: '直播',
//       class: 'h2',
//     },
//     {
//       value: `若因網路連線、電力供應或天氣等不可預見因素導致直播在鬥雞開賽前中斷，
//                 如果遊戲畫面未顯示比賽，所有下注將被退還。`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '擂台管理決定',
//       class: 'h2',
//     },
//     {
//       value: `擂台管理有權取消任何比賽；關於擂台決策的公告將逐案發布。<br />
//                 1. 比賽開始後，但擂台管理判定鬥雞受傷。如雙方鬥雞均未出現割傷或流血情況，
//                 擂台管理有權取消比賽。<br />
//                 2. 任何其他無法預見的事件。`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '未及時關閉下注',
//       class: 'h2',
//     },
//     {
//       value: `由於不可預期的技術問題，賽事開始後下的注將視為無效並退還給會員。`,
//       class: 'inline-right',
//     },
//     {
//       value: '<br />',
//       class: 'break',
//     },
//     {
//       value: '條款及條件',
//       class: 'm-r-8',
//     },
//     {
//       value: `<a href="#">使用條款</a>`,
//       class: 'inline-right',
//       type: 'link',
//       link: 'tnc',
//     },
//   ],
// };

export const JACKPOT_HELP_GUIDE = {
  en: [
    {
      value: 'Ante for Jackpot Game',
      class: 'h1',
    },
    {
      value: `Along with your bet, a small portion (known as the "ante") is 
      automatically collected and added to the jackpot pool. This pool is a 
      special fund that accumulates over time, contributed to by all players participating in the game.
      `,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
    {
      value: 'Accumulating Progress for Jackpot Game',
      class: 'h1',
    },
    {
      value: `Each time you play, you make progress towards triggering the jackpot game. 
      This progress is measured through a meter that fills up a little more each time you bet.
      `,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
    {
      value: `game-help/jackpot/progress-en.webp`,
      type: 'image',
      class: 'w-full',
    },
    {
      value: 'Jackpot Game Occurrence',
      class: 'h1',
    },
    {
      value: `Once you have accumulated enough progress, the jackpot game is triggered. 
      This is a special event where you have the chance to win big prizes.
        `,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
  ],
  vn: [
    {
      value: 'ANTE CHO TRÒ CHƠI JACKPOT',
      class: 'h1',
    },
    {
      value: `Cùng với cược của bạn, một phần nhỏ (gọi là "ante") sẽ tự động được 
      thu thập và thêm vào quỹ jackpot. Quỹ này là một khoản tiền đặc biệt tích lũy 
      theo thời gian, do tất cả người chơi tham gia trò chơi đóng góp.
      `,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
    {
      value: 'TIẾN ĐỘ TÍCH LŨY CHO TRÒ CHƠI JACKPOT',
      class: 'h1',
    },
    {
      value: `Mỗi lần bạn chơi, bạn sẽ tiến bộ trong việc kích hoạt trò chơi jackpot. 
      Tiến độ này được đo lường qua một mét số liệu, lấp đầy một chút mỗi lần bạn đặt cược.
      `,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
    {
      value: `game-help/jackpot/progress-en.webp`,
      type: 'image',
      class: 'w-full',
    },
    {
      value: 'XUẤT HIỆN TRÒ CHƠI JACKPOT',
      class: 'h1',
    },
    {
      value: `Khi bạn tích lũy đủ tiến trình, trò chơi jackpot sẽ được kích hoạt. 
      Đây là một sự kiện đặc biệt nơi bạn có cơ hội giành được những giải thưởng lớn.
        `,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
  ],
  th: [
    {
      value: 'การเดิมพันเพื่อเข้าร่วมเกมแจ็คพอต',
      class: 'h1',
    },
    {
      value: `พร้อมกับการเดิมพันของคุณ, ส่วนเล็กๆ (ที่เรียกว่า "การเดิมพันแรก") 
      จะถูกเก็บไว้โดยอัตโนมัติและเพิ่มเข้าไปในกองเงินแจ็คพอต. กองเงินนี้เป็นกองทุนพิเศษที่สะสมไปเรื่อยๆ 
      โดยมีการสนับสนุนจากผู้เล่นทุกคนที่เข้าร่วมเกม.
      `,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
    {
      value: 'สะสมความคืบหน้าเพื่อเกมแจ็คพอต',
      class: 'h1',
    },
    {
      value: `ทุกครั้งที่คุณเล่น, คุณจะทำความคืบหน้าเพื่อเปิดใช้งานเกมแจ็คพอต. 
      ความคืบหน้านี้จะถูกวัดผ่านมิเตอร์ที่เติมขึ้นเล็กน้อยทุกครั้งที่คุณวางเดิมพัน.
      `,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
    {
      value: `game-help/jackpot/progress-en.webp`,
      type: 'image',
      class: 'w-full',
    },
    {
      value: 'เกิดเหตุการณ์เกมแจ็คพอต',
      class: 'h1',
    },
    {
      value: `เมื่อคุณสะสมความคืบหน้าได้เพียงพอ, เกมแจ็คพอตจะถูกเริ่มต้น. 
      นี่คือเหตุการณ์พิเศษที่คุณมีโอกาสชนะรางวัลใหญ่.
        `,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
  ],
  id: [
    {
      value: 'ANTE UNTUK PERMAINAN JACKPOT',
      class: 'h1',
    },
    {
      value: `Bersamaan dengan taruhan Anda, sebuah bagian kecil (dikenal sebagai "ante") 
      secara otomatis dikumpulkan dan ditambahkan ke kolam jackpot. Kolam ini adalah dana 
      khusus yang terakumulasi dari waktu ke waktu, dengan kontribusi dari semua pemain yang 
      berpartisipasi dalam permainan.
      `,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
    {
      value: 'MENGAKUMULASI PROGRES UNTUK PERMAINAN JACKPOT',
      class: 'h1',
    },
    {
      value: `Setiap kali Anda bermain, Anda membuat kemajuan menuju pemicu permainan jackpot. 
      Kemajuan ini diukur melalui sebuah meter yang terisi sedikit lebih banyak setiap kali Anda bertaruh.
      `,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
    {
      value: `game-help/jackpot/progress-en.webp`,
      type: 'image',
      class: 'w-full',
    },
    {
      value: 'TERJADINYA PERMAINAN JACKPOT',
      class: 'h1',
    },
    {
      value: `Setelah Anda mengakumulasi cukup progres, permainan jackpot dipicu. Ini adalah 
      sebuah acara spesial di mana Anda memiliki kesempatan untuk memenangkan hadiah besar.
        `,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
  ],
  zh: [
    {
      value: '奖池游戏的底注',
      class: 'h1',
    },
    {
      value: `与您的投注同时，一小部分（称为“底注”）会自动收集并添加到累积奖池中。
      这个奖池是一个特殊的基金，随着时间的推移而累积，由所有参与游戏的玩家共同贡献。
      `,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
    {
      value: '奖池游戏的进度累积',
      class: 'h1',
    },
    {
      value: `每次您玩游戏时，都会向触发游戏奖池的目标迈进一步。这个进度通过一个计量器来计算，每次您投注时，计量器就会稍微增加一点。
      `,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
    {
      value: `game-help/jackpot/progress-en.webp`,
      type: 'image',
      class: 'w-full',
    },
    {
      value: '游戏奖池',
      class: 'h1',
    },
    {
      value: `一旦您累积了足够的进度，奖池游戏就会被触发。这是一个特别的事件，您有机会赢得大奖。
        `,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
  ],
  kr: [
    { value: '잭팟 게임의 앤티', class: 'h1' },
    {
      value: `베팅할 때마다 소액의 금액(“앤티”라고 함)이 자동으로 징수되어 
    잭팟 상금 풀에 추가됩니다. 이 상금 풀은 시간이 지남에 따라 누적되며, 
    게임에 참여하는 모든 플레이어들이 기여합니다.`,
      class: 'inline ',
    },
    { value: '<br />', class: 'break' },
    { value: '잭팟 게임 누적 진행도', class: 'h1' },
    {
      value: `게임을 플레이할 때마다 잭팟 게임을 발동시키기 위한 진행도가 쌓입니다. 
    이 진행도는 베팅할 때마다 조금씩 채워지는 미터기로 표시됩니다.`,
      class: 'inline ',
    },
    { value: '<br />', class: 'break' },
    {
      value: `game-help/jackpot/progress-en.webp`,
      type: 'image',
      class: 'w-full',
    },
    { value: '잭팟 게임 발생', class: 'h1' },
    {
      value: `충분한 진행도를 달성하면 잭팟 게임이 시작됩니다. 
    이 특별한 이벤트에서는 큰 보상을 받을 수 있는 기회가 주어집니다.`,
      class: 'inline ',
    },
    { value: '<br />', class: 'break' },
  ],
  jp: [
    { value: 'ジャックポットゲームのアンティ', class: 'h1' },
    {
      value: `ベットと同時に、「アンティ」と呼ばれる少額の金額が自動的に徴収され、
    ジャックポットプールに追加されます。このプールは特別な資金で、
    時間とともに蓄積され、ゲームに参加している全プレイヤーによって貢献されます。`,
      class: 'inline ',
    },
    { value: '<br />', class: 'break' },
    { value: 'ジャックポットゲームの進捗蓄積', class: 'h1' },
    {
      value: `プレイするたびに、ジャックポットゲーム発動への進捗が溜まっていきます。
    この進捗は、ベットするたびに少しずつ進むメーターで表示されます。`,
      class: 'inline ',
    },
    { value: '<br />', class: 'break' },
    {
      value: `game-help/jackpot/progress-en.webp`,
      type: 'image',
      class: 'w-full',
    },
    { value: 'ジャックポットゲームの発生', class: 'h1' },
    {
      value: `十分な進捗が蓄積されると、ジャックポットゲームが発動されます。
    この特別なイベントでは、大きな賞品を獲得するチャンスがあります。`,
      class: 'inline ',
    },
    { value: '<br />', class: 'break' },
  ],
  es: [
    { value: 'Apuesta Inicial para el Juego del Bote', class: 'h1' },
    {
      value: `Junto con tu apuesta, una pequeña porción (conocida como "apuesta inicial" o "ante") 
    se recoge automáticamente y se añade al fondo del bote. Este fondo es una 
    reserva especial que se acumula con el tiempo, aportada por todos los jugadores que participan en el juego.`,
      class: 'inline ',
    },
    { value: '<br />', class: 'break' },
    { value: 'Progreso Acumulado para el Juego del Bote', class: 'h1' },
    {
      value: `Cada vez que juegas, avanzas hacia activar el juego del bote. 
    Este progreso se mide mediante un medidor que se llena un poco más con cada apuesta que haces.`,
      class: 'inline ',
    },
    { value: '<br />', class: 'break' },
    {
      value: `game-help/jackpot/progress-en.webp`,
      type: 'image',
      class: 'w-full',
    },
    { value: 'Activación del Juego del Bote', class: 'h1' },
    {
      value: `Una vez que hayas acumulado suficiente progreso, se activa el juego del bote. 
    Este es un evento especial donde tienes la oportunidad de ganar grandes premios.`,
      class: 'inline ',
    },
    { value: '<br />', class: 'break' },
  ],
  pk: [
    { value: 'جیک پاٹ گیم کے لیے ابتدائی شرط', class: 'h1' },
    {
      value: `آپ کی شرط کے ساتھ ساتھ، ایک چھوٹا سا حصہ (جسے "ante" کہا جاتا ہے) 
    خود بخود جمع کیا جاتا ہے اور جیک پاٹ فنڈ میں شامل کیا جاتا ہے۔ یہ فنڈ 
    ایک خاص رقم ہے جو وقت کے ساتھ ساتھ تمام کھلاڑیوں کی شرکت سے جمع ہوتی ہے۔`,
      class: 'inline ',
    },
    { value: '<br />', class: 'break' },
    { value: 'جیک پاٹ گیم کے لیے ترقی کا حصول', class: 'h1' },
    {
      value: `ہر بار جب آپ کھیلتے ہیں، آپ جیک پاٹ گیم کو متحرک کرنے کی طرف پیش رفت کرتے ہیں۔ 
    یہ پیش رفت ایک میٹر کے ذریعے ماپی جاتی ہے جو ہر شرط کے ساتھ تھوڑا تھوڑا بھر جاتا ہے۔`,
      class: 'inline ',
    },
    { value: '<br />', class: 'break' },
    {
      value: `game-help/jackpot/progress-en.webp`,
      type: 'image',
      class: 'w-full',
    },
    { value: 'جیک پاٹ گیم کا آغاز', class: 'h1' },
    {
      value: `جب آپ کافی پیش رفت حاصل کر لیتے ہیں تو جیک پاٹ گیم متحرک ہو جاتا ہے۔ 
    یہ ایک خاص ایونٹ ہوتا ہے جہاں آپ کو بڑے انعامات جیتنے کا موقع ملتا ہے۔`,
      class: 'inline ',
    },
    { value: '<br />', class: 'break' },
  ],
  mm: [
    {
      value: 'Jackpot Game အတွက် Ante',
      class: 'h1',
    },
    {
      value: `သင်၏လောင်းကစားနှင့်အတူ "ante" ဟုခေါ်သော အနည်းငယ်ပမာဏကို
    အလိုအလျောက် စုဆောင်းကာ jackpot pool ထဲသို့ ထည့်သွင်းမည်။ ဤ pool သည်
    ကစားနေသည့် အားလုံးမှ စုဆောင်းသည့် အထူးသီးသန့် ရန်ပုံငွေတစ်ခု ဖြစ်ပြီး
    အချိန်တစ်လျှောက်လုံး တိုးပွားနေသည်။`,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
    {
      value: 'Jackpot Game အတွက် Progress စုဆောင်းခြင်း',
      class: 'h1',
    },
    {
      value: `သင်ကစားတိုင်း jackpot game ကို ဖွင့်နိုင်သော progress တိုးပွားနေသည်။
    ဤ progress ကို သင်လောင်းတိုင်း meter တစ်ခု တဖြည်းဖြည်း ပြည့်လာသည့်အနေဖြင့်
    ဖော်ပြထားသည်။`,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
    {
      value: `game-help/jackpot/progress-en.webp`,
      type: 'image',
      class: 'w-full',
    },
    {
      value: 'Jackpot Game ဖြစ်ပွားချိန်',
      class: 'h1',
    },
    {
      value: `လိုအပ်သည့် progress ကို ပြည့်မှီပြီးသည်နှင့် jackpot game ကို
    ဖွင့်မည်။ ဤသည်က သင်အကြီးမားဆုံး ဆုနိုင်ချေကို ရရှိနိုင်သည့်
    အထူး Event တစ်ခု ဖြစ်သည်။`,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
  ],
  bd: [
    {
      value: 'Jackpot Game এর জন্য Ante',
      class: 'h1',
    },
    {
      value: `আপনার বাজির সাথে সাথে "ante" নামে একটি ছোট অংশ
    স্বয়ংক্রিয়ভাবে সংগ্রহ হয়ে jackpot pool এ যুক্ত হয়।
    এই pool একটি বিশেষ তহবিল যা সময়ের সাথে সাথে
    গেমে অংশগ্রহণকারী সকল খেলোয়াড়ের অবদান দ্বারা বৃদ্ধি পায়।`,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
    {
      value: 'Jackpot Game এর জন্য Progress জমা হওয়া',
      class: 'h1',
    },
    {
      value: `প্রতিবার খেলার সময় jackpot game সক্রিয় হওয়ার দিকে
    আপনার progress বৃদ্ধি পায়। এটি একটি meter এর মাধ্যমে
    দেখানো হয় যা প্রতিবার বাজি ধরলে একটু একটু করে পূরণ হয়।`,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
    {
      value: `game-help/jackpot/progress-en.webp`,
      type: 'image',
      class: 'w-full',
    },
    {
      value: 'Jackpot Game অনুষ্ঠিত হওয়া',
      class: 'h1',
    },
    {
      value: `যখন পর্যাপ্ত progress জমা হবে, তখন jackpot game সক্রিয় হবে।
    এটি একটি বিশেষ event যেখানে বড় পুরস্কার জেতার সুযোগ থাকবে।`,
      class: 'inline ',
    },
    {
      value: '<br />',
      class: 'break',
    },
  ],
};

export const getLuckyDrawInstantPrizeHelpGuide = (taxPercentage?: number, language?: string) => {
  const taxDisplay = taxPercentage ? ` (${taxPercentage}%)` : '';

  const guides = {
    en: [
      {
        value: `Welcome to our game!`,
        class: 'h1',
      },
      {
        value: `Here's a simple guide to help you understand how it works:`,
        class: 'h2',
      },
      {
        value: `1. <span class="bold text-white">Ante Fees${taxDisplay}:</span> Every time you place a bet, a small percentage
      <span class="bold"></span> of your bet amount is collected as an ante fee. 
      These fees add up and create a prize pool.`,
      },
      {
        value:
          'Note: Bet on <span class="bold text-green">Draw</span> have no ante fee and no jackpot progress. <span class="bold text-red">Banker</span>/<span class="bold text-blue">Player</span> bets are fully refunded, including any ante fee, if the fight ends in Draw or is Cancelled.',
      },
      {
        value: `2. <span class="bold text-white">Jackpot Games:</span> The ante fees collected are pooled together
       to form a jackpot. Members have the chance to win from this jackpot by participating in various
       jackpot games.`,
      },
      {
        value: `3. <span class="bold text-white">How to Win:</span> In our current active jackpot game, Members earn 
      a ticket when they meet certain turnover requirements through their bets. Once you have a ticket, you instantly 
      collect a payout from the prize pool. At the end of the event, all tickets are entered into a lucky draw where 
      winners are selected randomly. If your ticket is chosen, you win additional prizes!`,
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/lucky-draw-instant-prize-custom.webp`,
        type: 'image',
        class: 'w-full desktop',
      },
      {
        value: `So, by playing and placing bets, not only do you have the chance to win individual prizes, 
      but you also contribute to the collective jackpot. It's a fun and exciting way to enjoy the game 
      and potentially win big rewards!
          `,
        class: 'inline ',
      },
      {
        value: 'Accumulating Progress for Jackpot Game',
        class: 'h1',
      },
      {
        value: `Each time you play, you make progress towards triggering the jackpot game. This progress 
      is measured through a meter that fills up a little more each time you bet.
          `,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/progress-en.webp`,
        type: 'image',
        class: 'w-full',
      },
      {
        value: 'Understanding Ticket Tiers: Minor, Mini, and Major',
        class: 'h1',
      },
      {
        value: `As members engage in betting, they earn tickets based on 
      their betting turnover, progressing through tiers as follows:
          `,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/mini.png',
          headerText: 'Mini',
          listArray: [`&bull; Instant Payout: Earn up to $50 USD`, `&bull; Lucky Draw : Chance to win Mini Payout`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/minor.png',
          headerText: 'Minor',
          listArray: [`&bull; Instant Payout: Earn up to $250 USD`, `&bull; Lucky Draw : Chance to win Minor Payout`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/major.png',
          headerText: 'Major',
          listArray: [`&bull; Instant Payout: Earn up to $500 USD`, `&bull; Lucky Draw : Chance to win Major Payout`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `Begin at the Mini tier and work your way up by 
      meeting the turnover requirements and collecting the necessary 
      number of tickets at each level.
          `,
        class: 'inline ',
      },
    ],
    vn: [
      {
        value: `Chào mừng đến với trò chơi của chúng tôi!`,
        class: 'h1',
      },
      {
        value: `Dưới đây là hướng dẫn đơn giản để giúp bạn hiểu cách thức hoạt động của trò chơi:`,
        class: 'h2',
      },
      {
        value: `1. <span class="bold text-white">Phí đặt cược ${taxDisplay} :</span> Mỗi lần bạn đặt cược, một tỉ lệ nhỏ 
      <span class="bold"></span> số tiền đặt cược của bạn sẽ được thu dưới dạng phí đặt cược. Các khoản phí này 
      cộng lại và tạo ra một quỹ giải thưởng.`,
      },
      {
        value:
          'Lưu ý: Cược vào <span class="bold text-green">Draw</span> không có phí trả trước và không được tính vào tiến độ hũ thưởng. Cược <span class="bold text-red">ĐỎ</span>/<span class="bold text-blue">XANH</span> sẽ được hoàn tiền đầy đủ, bao gồm mọi phí trả trước, nếu trận đấu kết thúc Hòa hoặc bị hủy.',
      },
      {
        value: `2. <span class="bold text-white">Trò chơi Jackpot: </span> Phí đặt cược thu được sẽ 
      được tích lũy lại để tạo thành giải jackpot. Các thành viên có cơ hội giành được các giải thưởng jackpot khi 
      đặt đủ số tiền đặt cược theo từng mốc.`,
      },
      {
        value: `3. <span class="bold text-white">Cách giành chiến thắng:</span> Jackpot sẽ thay đổi 
      theo thời gian, Thành viên sẽ kiếm được một vé khi họ đạt đủ số tiền cược nhất định thông qua đặt cược của
      mình. Sau khi có vé, bạn sẽ ngay lập tức nhận được khoản thanh toán từ giải thưởng. Vào cuối sự kiện, tất cả 
      các vé sẽ được rút thăm may mắn trong đó người chiến thắng được chọn ngẫu nhiên (số vé ngẫu nhiên). Nếu vé của
       bạn được chọn, bạn sẽ giành được giải thưởng Jackpot lớn nhất!
      `,
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/lucky-draw-instant-prize-custom.webp`,
        type: 'image',
        class: 'w-full desktop',
      },
      {
        value: `Vì vậy, bằng cách chơi và đặt cược, bạn không chỉ có cơ hội giành được các giải thưởng cá
      nhân mà còn góp phần vào giải độc đắc. Đó là một cách thú vị và hấp dẫn để tận hưởng trò
      chơi và có khả năng giành được những phần thưởng lớn!
          `,
        class: 'inline ',
      },
      {
        value: 'Tiến độ Tích lũy cho trò chơi Jackpot',
        class: 'h1',
      },
      {
        value: `Mỗi lần bạn chơi, bạn sẽ tích điểm trong trò chơi jackpot. Tiến trình này được đo thông qua một
      thước đo sẽ đầy thêm một chút mỗi lần bạn đặt cược.
          `,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/progress-en.webp`,
        type: 'image',
        class: 'w-full',
      },
      {
        value: 'Tìm hiểu về Hũ nhỏ, Hũ Trung và Hũ Lớn',
        class: 'h1',
      },
      {
        value: `Khi các thành viên tham gia cá cược, họ kiếm được vé dựa trên tổng tiền cược của mình, tiến 
      triển qua các cấp độ như sau:
          `,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/mini.png',
          headerText: 'Mini',
          listArray: [
            `&bull; Thanh toán Ngay lập tức: Kiếm được lên đến 50 đô la Mỹ`,
            `&bull; Miễn Phí: Cơ hội để giành Mini payout`,
          ],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/minor.png',
          headerText: 'Minor',
          listArray: [
            `&bull; Thanh toán Ngay lập tức: Kiếm được lên đến 250 đô la Mỹ`,
            `&bull; Miễn Phí: Cơ hội để giành Minor Payout`,
          ],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/major.png',
          headerText: 'Major',
          listArray: [
            `&bull; Thanh toán Ngay lập tức: Kiếm được lên đến 500 đô la Mỹ`,
            `&bull; Rút Thăm May Mắn: Cơ hội giành được Major payout`,
          ],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `Bắt đầu ở cấp Hũ nhỏ và tăng dần theo các yêu cầu về doanh thu và thu thập số lượng vé cần 
      thiết ở mỗi cấp.
          `,
        class: 'inline ',
      },
    ],
    th: [
      {
        value: `ยินดีต้อนรับสู่เกมของเรา!`,
        class: 'h1',
      },
      {
        value: `คำแนะนำง่ายๆ ที่จะช่วยให้คุณเข้าใจวิธีการทำงานมีดังนี้`,
        class: 'h2',
      },
      {
        value: `1. <span class="bold text-white">อันเต้${taxDisplay}:</span> ทุกครั้งที่คุณวางเดิมพันเปอร์เซ็นต์เล็กน้อย
      <span class="bold"></span>  ของจำนวนเงินเดิมพันของคุณจะถูกเก็บเป็นค่าธรรมเนียมล่วงหน้า 
      ค่าธรรมเนียมเหล่านี้รวมกันและสร้างเงินรางวัลรวม`,
      },
      {
        value:
          'หมายเหตุ: การเดิมพัน Draw ไม่มี อันเต้ และไม่นับรวมในความคืบหน้าแจ็กพอต <span class="bold text-red">Banker</span>/<span class="bold text-blue">Player</span> bets จะได้รับ คืนเงินให้ เต็มจำนวน รวมถึง อันเต้ หากไฟต์จบเป็น Draw หรือถูกยกเลิก ',
      },
      {
        value: `2. <span class="bold text-white">เกมแจ็คพอต:</span> 
      ค่าธรรมเนียมล่วงหน้าที่รวบรวมจะถูกรวมเข้าด้วยกันเพื่อสร้างแจ็คพอต 
      สมาชิกมีโอกาสที่จะชนะรางวัลแจ็คพอตนี้จากการเข้าร่วมเกมแจ็คพอตต่างๆ`,
      },
      {
        value: `3. <span class="bold text-white">วิธีชนะ:</span> ในเกมแจ็คพอตที่ใช้งานอยู่ในปัจจุบันของเรา 
      สมาชิกจะได้รับตั๋วเมื่อพวกเขามีคุณสมบัติครบตามข้อกำหนดในการเดิมพันผ่านการเดิมพัน เมื่อคุณมีตั๋วแล้ว
       คุณจะรับการจ่ายเงินจากกองรางวัลทันที เมื่อสิ้นสุดกิจกรรม ตั๋วทั้งหมดจะเข้าสู่การจับรางวัลโดยสุ่มเลือกผู้ชนะ 
       หากตั๋วของคุณถูกเลือก คุณจะได้รับรางวัลเพิ่มเติม!
      `,
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/lucky-draw-instant-prize-custom.webp`,
        type: 'image',
        class: 'w-full desktop',
      },
      {
        value: `ดังนั้นโดยการเล่นและการวางเดิมพัน ไม่เพียงแต่คุณมีโอกาสที่จะชนะรางวัลส่วนบุคคลเท่านั้น 
      แต่คุณยังมีส่วนร่วมในแจ็คพอตรวมอีกด้วย 
      มันเป็นวิธีที่สนุกและน่าตื่นเต้นในการเพลิดเพลินกับเกมและอาจได้รับรางวัลใหญ่!
          `,
        class: 'inline ',
      },
      {
        value: 'สะสมความคืบหน้าสำหรับเกมแจ็คพอต',
        class: 'h1',
      },
      {
        value: `แต่ละครั้งที่คุณเล่น คุณจะก้าวหน้าไปสู่การเรียกเกมแจ็คพอต 
      ความคืบหน้านี้วัดผ่านมิเตอร์ที่เติมเพิ่มขึ้นเล็กน้อยทุกครั้งที่คุณเดิมพัน
          `,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/progress-en.webp`,
        type: 'image',
        class: 'w-full',
      },
      {
        value: 'ทำความเข้าใจเกี่ยวกับระดับตั๋ว: ไมเนอร์ มินิ และเมเจอร์',
        class: 'h1',
      },
      {
        value: `เมื่อสมาชิกมีส่วนร่วมในการเดิมพัน พวกเขาจะได้รับตั๋วตามมูลค่าการเดิมพัน โดยจะผ่านระดับต่างๆ ดังต่อไปนี้:
          `,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/mini.png',
          headerText: 'มินิ',
          listArray: [`&bull; การจ่ายเงินทันที: รับสูงถึง $50 USD`, `&bull; Lucky Draw : โอกาสชนะรางวัล Mini Payout`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/minor.png',
          headerText: 'ไมเนอร์',
          listArray: [`&bull; การจ่ายเงินทันที: รับสูงถึง $250 USD`, `&bull; Lucky Draw : โอกาสชนะรางวัล Minor Payout`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/major.png',
          headerText: 'เมเจอร์',
          listArray: [`&bull; การจ่ายเงินทันที: รับสูงถึง $500 USD`, `&bull; Lucky Draw : โอกาสชนะรางวัลใหญ่`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `เริ่มต้นที่ระดับ Mini และค่อยๆ 
      ไต่ระดับขึ้นไปโดยปฏิบัติตามข้อกำหนดการหมุนเวียนและรวบรวมตั๋วตามจำนวนที่จำเป็นในแต่ละระดับ
          `,
        class: 'inline ',
      },
    ],
    id: [
      {
        value: `Selamat datang di permainan kami!`,
        class: 'h1',
      },
      {
        value: `Berikut panduan sederhana untuk membantu Anda memahami cara kerjanya:`,
        class: 'h2',
      },
      {
        value: `1. <span class="bold text-white">Biaya Ante${taxDisplay}:</span> Setiap kali Anda memasang taruhan, persentasenya kecil
      <span class="bold"></span>dari jumlah taruhan Anda dikumpulkan sebagai biaya ante. 
      Biaya ini bertambah dan menciptakan kumpulan hadiah.`,
      },
      {
        value:
          'Catatan: Bertaruh pada <span class="bold text-green">Draw</span> tidak dikenakan ante dan tidak dihitung dalam progres jackpot. <span class="bold text-red">Banker</span>/<span class="bold text-blue">Player</span> bets akan direfund penuh, termasuk ante jika fight berakhir Draw atau dibatalkan.',
      },
      {
        value: `2. <span class="bold text-white">Permainan Jackpot:</span> Biaya ante yang dikumpulkan 
      dikumpulkan bersama untuk membentuk jackpot. Member mempunyai kesempatan untuk memenangkan jackpot 
      ini dengan mengikuti berbagai permainan jackpot.`,
      },
      {
        value: `3. <span class="bold text-white">Cara Menang:</span> Dalam permainan jackpot aktif kami saat ini, 
      Anggota mendapatkan tiket ketika mereka memenuhi persyaratan turnover tertentu melalui taruhan mereka. 
      Setelah Anda memiliki tiket, Anda langsung mengumpulkan pembayaran dari kumpulan hadiah. Di akhir acara, 
      semua tiket dimasukkan ke dalam undian berhadiah yang pemenangnya dipilih secara acak. Jika tiket Anda terpilih, 
      Anda memenangkan hadiah tambahan!`,
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/lucky-draw-instant-prize-custom.webp`,
        type: 'image',
        class: 'w-full desktop',
      },
      {
        value: `Jadi, dengan bermain dan memasang taruhan, Anda tidak hanya berpeluang memenangkan hadiah individu, 
      namun Anda juga berkontribusi pada jackpot kolektif. Ini adalah cara yang menyenangkan dan mengasyikkan untuk 
      menikmati permainan dan berpotensi memenangkan hadiah besar!

          `,
        class: 'inline ',
      },
      {
        value: 'Mengumpulkan Kemajuan untuk Game Jackpot',
        class: 'h1',
      },
      {
        value: `Setiap kali Anda bermain, Anda membuat kemajuan dalam memicu permainan jackpot. Kemajuan ini 
      diukur melalui meteran yang terisi lebih banyak setiap kali Anda bertaruh.
          `,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/progress-en.webp`,
        type: 'image',
        class: 'w-full',
      },
      {
        value: 'Memahami Tingkatan Tiket: Minor, Mini, dan Major',
        class: 'h1',
      },
      {
        value: `Saat anggota terlibat dalam taruhan, mereka mendapatkan tiket berdasarkan omset taruhan mereka,
       yang maju melalui tingkatan sebagai berikut:
          `,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/mini.png',
          headerText: 'Mini',
          listArray: [
            `&bull; Pembayaran Instan: Dapatkan hingga $50 USD`,
            `&bull; Undian Berhadiah : Peluang memenangkan Pembayaran Mini`,
          ],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/minor.png',
          headerText: 'Minor',
          listArray: [
            `&bull; Pembayaran Instan: Dapatkan hingga $250 USD`,
            `&bull; Undian Berhadiah : Peluang memenangkan Pembayaran Kecil`,
          ],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/major.png',
          headerText: 'Besar',
          listArray: [
            `&bull; Pembayaran Instan: Dapatkan hingga $500 USD`,
            `&bull; Undian Berhadiah : Peluang memenangkan Pembayaran Besar`,
          ],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `Mulailah dari tingkat Mini dan tingkatkan dengan memenuhi persyaratan turnover 
      dan mengumpulkan jumlah tiket yang diperlukan di setiap level.

          `,
        class: 'inline ',
      },
    ],
    zh: [
      {
        value: `欢迎来到我们的游戏!`,
        class: 'h1',
      },
      {
        value: `这是一个简单的指南，可帮助您了解其工作原理：`,
        class: 'h2',
      },
      {
        value: `1. <span class="bold text-white">底注${taxDisplay}：</span> 每次下注时，都会有一小部分
      <span class="bold"></span>您的投注金额的一部分将作为底费收取。这些费用加起来就形成了一个奖池。`,
      },
      {
        value:
          '注意：投注<span class="bold text-white">平局</span>不收取底注，也不计入奖池进度。若赛事结果为平局或取消，<span class="bold text-red">庄</span>/<span class="bold text-blue">闲</span>投注将全额退还，包括任何底注。',
      },
      {
        value: `2. <span class="bold text-white">大奖游戏：</span>收集到的底注费用汇集在一起​​形成累积奖金。
      会员有机会通过参加各种累积奖金游戏来赢得该累积奖金。
      `,
      },
      {
        value: `3. <span class="bold text-white">如何取胜：</span> 在我们目前活跃的累积奖金游戏中，
      会员通过投注达到一定的流水要求时即可获得彩票。获得彩票后，您可以立即从奖池中领取奖金。活动结束时，
      所有门票都将参加抽奖，随机选出获奖者。如果您的门票被选中，您将赢得额外奖品！`,
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/lucky-draw-instant-prize-custom.webp`,
        type: 'image',
        class: 'w-full desktop',
      },
      {
        value: `因此，通过玩游戏和下注，您不仅有机会赢得个人奖金，还可以为集体累积奖金做出贡献。
      这是一种有趣且令人兴奋的方式来享受游戏并有可能赢得丰厚奖励！
          `,
        class: 'inline ',
      },
      {
        value: '累积奖金游戏进度',
        class: 'h1',
      },
      {
        value: `每次玩时，您都会在触发累积奖金游戏方面取得进展。这个进度是通过一个仪表来衡量的，每次你下注，仪表就会填满一点。
          `,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/progress-en.webp`,
        type: 'image',
        class: 'w-full',
      },
      {
        value: '了解门票等级：迷你、小奖和大奖',
        class: 'h1',
      },
      {
        value: `当会员参与投注时，他们会根据投注额赚取彩票，等级如下：
          `,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/mini.png',
          headerText: '迷你',
          listArray: [`&bull; 即时付款：赚取高达50美元`, `&bull; 幸运抽奖：有机会赢取迷你奖金`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/minor.png',
          headerText: '小奖',
          listArray: [`&bull; 即时付款：赚取高达250美元`, `&bull; 幸运抽奖：有机会赢得小额奖金`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/major.png',
          headerText: '大奖',
          listArray: [`&bull; 即时付款：赚取高达500美元`, `&bull; 幸运抽奖：有机会赢取大奖`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `从迷你级别开始，通过满足营业额要求并收集每个级别所需数量的门票来逐步提升。
          `,
        class: 'inline ',
      },
    ],
    kr: [
      { value: '게임에 오신 것을 환영합니다!', class: 'h1' },
      { value: '게임 작동 방식에 대한 간단한 가이드를 소개합니다:', class: 'h2' },
      {
        value: `1. <span class="bold text-white">앤티 수수료${taxDisplay}:</span> 베팅할 때마다 베팅 금액의 일부가 
    <span class="bold"></span> 앤티 수수료로 징수됩니다. 이 수수료는 누적되어 상금 풀을 형성합니다.`,
      },
      {
        value:
          '참고: 무승부에 베팅하면 앤티 수수료가 없으며 잭팟 진행도에 반영되지 않습니다. 경기가 무승부로 끝나거나 취소되면 <span class="bold text-red">Banker</span>/<span class="bold text-blue">Player</span> 베팅은 앤티 수수료를 포함해 전액 환불됩니다. ',
      },
      {
        value: `2. <span class="bold text-white">잭팟 게임:</span> 모인 앤티 수수료는 잭팟 상금으로 사용되며, 
    다양한 잭팟 게임에 참여하여 이 상금을 받을 수 있는 기회를 얻게 됩니다.`,
      },
      {
        value: `3. <span class="bold text-white">당첨 방법:</span> 현재 진행 중인 잭팟 게임에서 
    회원은 일정 베팅 금액을 달성하면 티켓을 획득합니다. 티켓을 얻으면 즉시 상금 풀에서 보상을 받습니다. 
    이벤트 종료 시, 모든 티켓이 추첨에 등록되며 무작위로 당첨자가 선정되어 추가 보상을 받을 수 있습니다!`,
      },
      { value: '<br />', class: 'break' },
      {
        value: `game-help/jackpot/lucky-draw-instant-prize-custom.webp`,
        type: 'image',
        class: 'w-full desktop',
      },
      {
        value: `즉, 게임을 즐기며 베팅할수록 개인 보상을 받을 기회뿐 아니라 
    공동 잭팟에 기여하게 됩니다. 재미있고 짜릿한 방식으로 큰 보상을 노려보세요!`,
        class: 'inline ',
      },
      { value: '잭팟 게임 누적 진행도', class: 'h1' },
      {
        value: `게임을 플레이할 때마다 잭팟 게임 진행도가 쌓입니다. 
    이 진행도는 베팅할 때마다 조금씩 채워지는 미터기로 표시됩니다.`,
        class: 'inline ',
      },
      { value: '<br />', class: 'break' },
      {
        value: `game-help/jackpot/progress-en.webp`,
        type: 'image',
        class: 'w-full',
      },
      { value: '티켓 등급 이해하기: 마이너, 미니, 메이저', class: 'h1' },
      {
        value: `회원은 베팅 금액에 따라 티켓을 획득하며 다음과 같은 등급을 통해 진행됩니다:`,
        class: 'inline ',
      },
      { value: '<br />', class: 'break' },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/mini.png',
          headerText: '미니',
          listArray: [`&bull; 즉시 보상: 최대 $50 USD 획득 가능`, `&bull; 추첨: 미니 등급 보상 당첨 기회`],
        },
      },
      { value: '<br />', class: 'break' },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/minor.png',
          headerText: '마이너',
          listArray: [`&bull; 즉시 보상: 최대 $250 USD 획득 가능`, `&bull; 추첨: 마이너 등급 보상 당첨 기회`],
        },
      },
      { value: '<br />', class: 'break' },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/major.png',
          headerText: '메이저',
          listArray: [`&bull; 즉시 보상: 최대 $500 USD 획득 가능`, `&bull; 추첨: 메이저 등급 보상 당첨 기회`],
        },
      },
      { value: '<br />', class: 'break' },
      {
        value: `미니 등급부터 시작하여 각 등급의 베팅 조건을 충족하고 
    필요한 티켓 수를 모으면 다음 등급으로 진입할 수 있습니다.`,
        class: 'inline ',
      },
    ],
    jp: [
      { value: 'ゲームへようこそ！', class: 'h1' },
      { value: 'ゲームの仕組みを簡単にご案内します：', class: 'h2' },
      {
        value: `1. <span class="bold text-white">アンティ手数料${taxDisplay}:</span> ベットするたびに、ベット金額の一部が
    <span class="bold"></span> アンティ手数料として差し引かれます。これらの手数料が積み重なって賞金プールが作られます。`,
      },
      {
        value:
          '注意：引き分けへのベットにはアンティ手数料はかからず、ジャックポット進行度にもカウントされません。試合が引き分けまたはキャンセルになった場合、<span class="bold text-red">Banker</span>/<span class="bold text-blue">Player</span>のベットはアンティ手数料を含めて全額返金されます。',
      },
      {
        value: `2. <span class="bold text-white">ジャックポットゲーム:</span> 集められたアンティ手数料は
    ジャックポットとしてプールされます。メンバーはさまざまなジャックポットゲームに参加して、
    この賞金を獲得するチャンスがあります。`,
      },
      {
        value: `3. <span class="bold text-white">勝利の方法:</span> 現在のジャックポットゲームでは、メンバーが
    一定のベット額に達するとチケットを獲得できます。チケットを取得すると、すぐに賞金プールから報酬がもらえます。
    イベント終了時には、すべてのチケットが抽選に参加し、ランダムに当選者が選ばれ、追加賞品を獲得できます！`,
      },
      { value: '<br />', class: 'break' },
      {
        value: `game-help/jackpot/lucky-draw-instant-prize-custom.webp`,
        type: 'image',
        class: 'w-full desktop',
      },
      {
        value: `プレイしてベットを行うことで、個別の賞金を獲得するチャンスがあるだけでなく、全体のジャックポットにも貢献します。
    楽しみながら大きな報酬を狙いましょう！`,
        class: 'inline ',
      },
      { value: 'ジャックポットゲームの進捗蓄積', class: 'h1' },
      {
        value: `プレイするたびにジャックポットゲームの進捗が蓄積されます。
    ベットごとに進捗メーターが少しずつ増えていきます。`,
        class: 'inline ',
      },
      { value: '<br />', class: 'break' },
      {
        value: `game-help/jackpot/progress-en.webp`,
        type: 'image',
        class: 'w-full',
      },
      { value: 'チケットのティアについて：マイナー、ミニ、メジャー', class: 'h1' },
      {
        value: `メンバーはベット金額に応じてチケットを獲得し、次のようなティアに進みます：`,
        class: 'inline ',
      },
      { value: '<br />', class: 'break' },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/mini.png',
          headerText: 'ミニ',
          listArray: [`&bull; 即時報酬：最大 $50 USD を獲得`, `&bull; 抽選：ミニ賞金が当たるチャンス`],
        },
      },
      { value: '<br />', class: 'break' },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/minor.png',
          headerText: 'マイナー',
          listArray: [`&bull; 即時報酬：最大 $250 USD を獲得`, `&bull; 抽選：マイナー賞金が当たるチャンス`],
        },
      },
      { value: '<br />', class: 'break' },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/major.png',
          headerText: 'メジャー',
          listArray: [`&bull; 即時報酬：最大 $500 USD を獲得`, `&bull; 抽選：メジャー賞金が当たるチャンス`],
        },
      },
      { value: '<br />', class: 'break' },
      {
        value: `まずはミニティアから始めて、各ティアの条件を達成し、
    必要なチケット数を集めて次のティアに進みましょう。`,
        class: 'inline ',
      },
    ],
    es: [
      { value: '¡Bienvenido a nuestro juego!', class: 'h1' },
      { value: 'Aquí tienes una guía simple para ayudarte a entender cómo funciona:', class: 'h2' },
      {
        value: `1. <span class="bold text-white">La cuota${taxDisplay}:</span> Cada vez que haces una apuesta, un pequeño porcentaje 
    <span class="bold"></span> de tu monto se cobra como cuota inicial. Estas cuotas se acumulan para formar un pozo de premios.`,
      },
      {
        value:
          'Nota: Apostar a <span class="bold text-green">Draw</span> no tiene cuota ni cuenta para el progreso del jackpot. <span class="bold text-red">Banker</span>/<span class="bold text-blue">Player</span> bets se reembolsarán por completo, incluido cualquier cuota, si la pelea termina en Draw o es cancelada.',
      },
      {
        value: `2. <span class="bold text-white">Juegos con Bote:</span> Las cuotas iniciales se agrupan para formar un bote. 
    Los miembros tienen la oportunidad de ganar participando en varios juegos con bote.`,
      },
      {
        value: `3. <span class="bold text-white">Cómo Ganar:</span> En el juego de bote activo, los miembros ganan 
    un boleto al cumplir ciertos requisitos de volumen de apuesta. Al obtener un boleto, se recibe un pago instantáneo del fondo de premios. 
    Al final del evento, todos los boletos entran en un sorteo donde los ganadores se eligen al azar. ¡Si tu boleto es elegido, ganas premios adicionales!`,
      },
      { value: '<br />', class: 'break' },
      {
        value: 'game-help/jackpot/lucky-draw-instant-prize-custom.webp',
        type: 'image',
        class: 'w-full desktop',
      },
      {
        value: `Así que, al jugar y apostar, no solo tienes la oportunidad de ganar premios individuales, 
    sino que también contribuyes al bote colectivo. ¡Es una forma divertida y emocionante de disfrutar el juego y ganar grandes recompensas!`,
        class: 'inline ',
      },
      { value: 'Acumulando Progreso para el Juego del Bote', class: 'h1' },
      {
        value: `Cada vez que juegas, avanzas hacia activar el juego del bote. 
    Este progreso se mide con un medidor que se llena un poco más con cada apuesta.`,
        class: 'inline ',
      },
      { value: '<br />', class: 'break' },
      {
        value: 'game-help/jackpot/progress-en.webp',
        type: 'image',
        class: 'w-full',
      },
      { value: 'Entendiendo los Niveles de Boletos: Menor, Mini y Mayor', class: 'h1' },
      {
        value: `A medida que los miembros apuestan, ganan boletos según su volumen de apuestas, 
    progresando a través de los siguientes niveles:`,
        class: 'inline ',
      },
      { value: '<br />', class: 'break' },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/mini.png',
          headerText: 'Mini',
          listArray: [`&bull; Pago instantáneo: Gana hasta $50 USD`, `&bull; Sorteo: Oportunidad de ganar premio Mini`],
        },
      },
      { value: '<br />', class: 'break' },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/minor.png',
          headerText: 'Menor',
          listArray: [
            `&bull; Pago instantáneo: Gana hasta $250 USD`,
            `&bull; Sorteo: Oportunidad de ganar premio Menor`,
          ],
        },
      },
      { value: '<br />', class: 'break' },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/major.png',
          headerText: 'Mayor',
          listArray: [
            `&bull; Pago instantáneo: Gana hasta $500 USD`,
            `&bull; Sorteo: Oportunidad de ganar premio Mayor`,
          ],
        },
      },
      { value: '<br />', class: 'break' },
      {
        value: `Comienza en el nivel Mini y avanza cumpliendo los requisitos de volumen y recolectando 
    la cantidad necesaria de boletos en cada nivel.`,
        class: 'inline ',
      },
    ],
    pt: [
      {
        value: `Bem-vindo ao nosso jogo!`,
        class: 'h1',
      },
      {
        value: `Aqui está um guia simples para ajudá-lo a entender como ele funciona:`,
        class: 'h2',
      },
      {
        value: `1. <span class="bold text-white">Taxas de Ante${taxDisplay}:</span> Cada vez que você faz uma aposta, uma pequena porcentagem
      <span class="bold"></span> do valor da sua aposta é retida como taxa de ante.
      Essas taxas se acumulam e formam um prêmio total.`,
      },
      {
        value:
          'Nota: Aposte em <span class="bold text-green">Empate</span> não há taxa de ante nem progresso no jackpot. Apostas em <span class="bold text-red">Banker</span>/<span class="bold text-blue">Player</span> são totalmente reembolsadas, incluindo qualquer taxa de ante, caso a luta termine em empate ou seja cancelada.',
      },
      {
        value: `2. <span class="bold text-white">Jogos Jackpot:</span> As taxas de ante coletadas são reunidas
       para formar um prêmio acumulado. Os membros têm a chance de ganhar esse prêmio participando de
       vários jogos com jackpot.`,
      },
      {
        value: `3. <span class="bold text-white">Como vencer:</span> Em nosso jogo de jackpot ativo atual, os membros ganham
      um bilhete ao cumprirem determinados requisitos de rollover por meio de suas apostas. Assim que você tiver um bilhete, receberá instantaneamente
      um pagamento do prêmio acumulado. Ao final do evento, todos os bilhetes participam de um sorteio
      onde os vencedores são selecionados aleatoriamente. Se o seu bilhete for sorteado, você ganha prêmios adicionais!`,
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/lucky-draw-instant-prize-custom.webp`,
        type: 'image',
        class: 'w-full desktop',
      },
      {
        value: `Assim, ao jogar e fazer apostas, você não só tem a chance de ganhar prêmios individuais,
      como também contribui para o prêmio acumulado. É uma maneira divertida e emocionante
      de aproveitar o jogo e, potencialmente, ganhar grandes recompensas!
          `,
        class: 'inline ',
      },
      {
        value: 'Progresso acumulado para o jogo Jackpot',
        class: 'h1',
      },
      {
        value: `A cada partida, você avança em direção ao jogo do jackpot. Esse progresso
      é medido por um medidor que se enche um pouco mais a cada aposta.
          `,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/progress-en.webp`,
        type: 'image',
        class: 'w-full',
      },
      {
        value: 'Entendendo as categorias de ingressos: Menor, Mini e Maior',
        class: 'h1',
      },
      {
        value: `À medida que os membros participam em apostas, ganham bilhetes com base no seu
      volume de apostas, progredindo através de níveis da seguinte forma:
          `,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/mini.png',
          headerText: 'Mini',
          listArray: [
            `&bull; Pagamento instantâneo: Ganhe até US$ 50`,
            `&bull; Sorteio: Chance de ganhar um pequeno prêmio`,
          ],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/minor.png',
          headerText: 'Menor',
          listArray: [
            `&bull; Pagamento instantâneo: Ganhe até US$ 250`,
            `&bull; Sorteio: Chance de ganhar um pequeno prêmio`,
          ],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/major.png',
          headerText: 'Principal',
          listArray: [
            `&bull; Pagamento instantâneo: Ganhe até US$ 500`,
            `&bull; Sorteio: Chance de ganhar um grande prêmio`,
          ],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `Comece no nível Mini e vá subindo, cumprindo os requisitos de faturamento e coletando o
      número necessário de ingressos em cada nível.
          `,
        class: 'inline ',
      },
    ],
    pk: [
      { value: 'ہمارے کھیل میں خوش آمدید!', class: 'h1' },
      { value: 'یہ ایک آسان رہنما ہے تاکہ آپ سمجھ سکیں کہ یہ کیسے کام کرتا ہے:', class: 'h2' },
      {
        value: `1. <span class="bold text-white">ابتدائی فیس${taxDisplay}:</span> جب بھی آپ شرط لگاتے ہیں، شرط کی رقم کا ایک چھوٹا سا حصہ 
    <span class="bold"></span> بطور ابتدائی فیس وصول کیا جاتا ہے۔ یہ فیسیں جمع ہو کر انعامی فنڈ بناتی ہیں۔`,
      },
      {
        value:
          'نوٹ: برابری پر شرط لگانے پر کوئی ابتدائی فیس نہیں لگتی اور یہ جیک پاٹ کی پیش رفت میں شمار نہیں ہوتی۔ اگر مقابلہ برابری پر ختم ہو یا منسوخ ہو جائے تو <span class="bold text-red">Banker</span>/<span class="bold text-blue">Player</span> کی شرطیں کسی بھی ابتدائی فیس سمیت مکمل واپس کر دی جائیں گی۔ ',
      },
      {
        value: `2. <span class="bold text-white">جیک پاٹ گیمز:</span> جمع شدہ ابتدائی فیسیں ملا کر جیک پاٹ بنتا ہے۔ 
    اراکین مختلف جیک پاٹ گیمز میں حصہ لے کر اس سے جیتنے کا موقع حاصل کرتے ہیں۔`,
      },
      {
        value: `3. <span class="bold text-white">جیتنے کا طریقہ:</span> موجودہ فعال جیک پاٹ گیم میں، جب اراکین مخصوص ٹرن اوور تقاضے پورے کرتے ہیں 
    تو انہیں ایک ٹکٹ ملتا ہے۔ جیسے ہی آپ کو ٹکٹ ملتا ہے، آپ انعامی فنڈ سے فوری رقم وصول کرتے ہیں۔ 
    ایونٹ کے اختتام پر، تمام ٹکٹ قرعہ اندازی میں شامل کیے جاتے ہیں جہاں فاتحین کا انتخاب تصادفی طور پر کیا جاتا ہے۔ 
    اگر آپ کا ٹکٹ منتخب ہوتا ہے، تو آپ کو اضافی انعامات ملتے ہیں!`,
      },
      { value: '<br />', class: 'break' },
      {
        value: 'game-help/jackpot/lucky-draw-instant-prize-custom.webp',
        type: 'image',
        class: 'w-full desktop',
      },
      {
        value: `تو، کھیلنے اور شرط لگانے سے نہ صرف آپ کو انفرادی انعامات جیتنے کا موقع ملتا ہے، 
    بلکہ آپ اجتماعی جیک پاٹ میں بھی حصہ ڈالتے ہیں۔ یہ کھیل سے لطف اندوز ہونے اور بڑے انعامات جیتنے کا ایک دلچسپ طریقہ ہے!`,
        class: 'inline ',
      },
      { value: 'جیک پاٹ گیم کے لیے ترقی کا حصول', class: 'h1' },
      {
        value: `جب بھی آپ کھیلتے ہیں، تو آپ جیک پاٹ گیم کو متحرک کرنے کی طرف ترقی کرتے ہیں۔ 
    یہ ترقی ایک میٹر کے ذریعے ماپی جاتی ہے جو ہر شرط کے ساتھ تھوڑا سا مزید بھرتا ہے۔`,
        class: 'inline ',
      },
      { value: '<br />', class: 'break' },
      {
        value: 'game-help/jackpot/progress-en.webp',
        type: 'image',
        class: 'w-full',
      },
      { value: 'ٹکٹ کی اقسام کو سمجھنا: مائنر، منی، اور میجر', class: 'h1' },
      {
        value: `جیسے جیسے اراکین شرط لگاتے ہیں، انہیں ان کے ٹرن اوور کی بنیاد پر ٹکٹ ملتے ہیں، 
    اور وہ درج ذیل درجات میں ترقی کرتے ہیں:`,
        class: 'inline ',
      },
      { value: '<br />', class: 'break' },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/mini.png',
          headerText: 'Mini',
          listArray: [`&bull; فوری ادائیگی: $50 USD تک جیتیں`, `&bull; قرعہ اندازی: Mini انعام جیتنے کا موقع`],
        },
      },
      { value: '<br />', class: 'break' },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/minor.png',
          headerText: 'Minor',
          listArray: [`&bull; فوری ادائیگی: $250 USD تک جیتیں`, `&bull; قرعہ اندازی: Minor انعام جیتنے کا موقع`],
        },
      },
      { value: '<br />', class: 'break' },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/major.png',
          headerText: 'Major',
          listArray: [`&bull; فوری ادائیگی: $500 USD تک جیتیں`, `&bull; قرعہ اندازی: Major انعام جیتنے کا موقع`],
        },
      },
      { value: '<br />', class: 'break' },
      {
        value: `Mini درجے سے آغاز کریں اور ٹرن اوور تقاضے پورے کر کے 
    اور ہر سطح پر مطلوبہ تعداد میں ٹکٹ حاصل کر کے آگے بڑھیں۔`,
        class: 'inline ',
      },
    ],
    mm: [
      {
        value: `ကျွန်ုပ်တို့၏ဂိမ်းသို့ ကြိုဆိုပါတယ်!`,
        class: 'h1',
      },
      {
        value: `ဂိမ်းအလုပ်လုပ်ပုံကို အလွယ်တကူ နားလည်စေဖို့ အောက်ပါလမ်းညွှန်ချက်ကို ကြည့်ပါ။`,
        class: 'h2',
      },
      {
        value: `1. <span class="bold text-white">Ante ကောက်ခံကြေး${taxDisplay}:</span> လောင်းကစားတစ်ကြိမ်တိုင်းတွင် လောင်းကြေးမှ
    အနည်းငယ်ကို ante fee အဖြစ် ကောက်ခံပါသည်။ ဤအခကြေးကြေးများကို စုပေါင်း၍ ဂုဏ်ထူးကြေးအဖြစ် ပေါ်ထွက်သည်။`,
      },
      {
        value:
          'မှတ်ချက်: သရေပေါ် လောင်းကြေးတွင် အန်တီကြေး မကောက်ခံပါ၊ ဂျက်ပေါ့တိုးတက်မှုတွင်လည်း မတွက်ပါ။ ပွဲသည် သရေကျလျှင် သို့မဟုတ် ဖျက်သိမ်းခံရလျှင် Banker/Player လောင်းကြေးများကို အန်တီကြေးအပါအဝင် အပြည့်အဝ ပြန်အမ်းပါမည်။ ',
      },
      {
        value: `2. <span class="bold text-white">Jackpot Games:</span> စုဆောင်းထားသော ante ကောက်ခံကြေး များကို
    jackpot pool တစ်ခုအဖြစ် ဖွဲ့စည်းပြီး မတူညီသော jackpot games များတွင် ပါဝင်ကစားခြင်းဖြင့် အနိုင်ရနိုင်သည်။`,
      },
      {
        value: `3. <span class="bold text-white">အနိုင်ရခြင်း ဘယ်လိုလုပ်မလဲ:</span> လက်ရှိ jackpot game တွင်၊
    အထူးသတ်မှတ်ထားသော turnover ကို ပြည့်မှီသောအခါ ticket ရရှိမည်။ Ticket ရရှိသည်နှင့်တစ်ပြိုင်နက်
    prize pool မှ ပေးချေမှု ရရှိမည်။ Event အပြီးတွင် ticket များအားလုံး lucky draw တွင် ဝင်ရောက်ပြီး
    ကံထူးသူများကို at random ရွေးချယ်မည်။ သင်၏ ticket တစ်စောင်တောင် ရွေးချယ်လျှင် ထပ်မံ ဆုများ ရရှိနိုင်သည်။`,
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/lucky-draw-instant-prize-custom.webp`,
        type: 'image',
        class: 'w-full desktop',
      },
      {
        value: `သင်ကစားခြင်းနှင့် လောင်းကစားခြင်းအားဖြင့် တစ်ကိုယ်ရည်ဆုများသာမက
    စုပေါင်း jackpot ထံတွင်လည်း လှူပေးနေသည်။ ဤအရာသည် ထူးခြားစရာနှင့်
    အနိုင်ရခြေများစွာရှိသော ကစားနည်းလေးဖြစ်သည်။`,
        class: 'inline ',
      },
      {
        value: 'Jackpot Game အတွက် Progress စုဆောင်းခြင်း',
        class: 'h1',
      },
      {
        value: `ကစားတိုင်း jackpot ကိုဖွင့်နိုင်သော progress ကို တိုးတက်စေမည်။
    ဤ progress သည် သင်လောင်းတိုင်း meter တစ်ခုတက်လာသလို ဖြစ်သည်။`,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/progress-en.webp`,
        type: 'image',
        class: 'w-full',
      },
      {
        value: 'Ticket အဆင့်များကို နားလည်ခြင်း: Minor, Mini နှင့် Major',
        class: 'h1',
      },
      {
        value: `လောင်းကြေး turnover ပမာဏအလိုက် ticket များရှာရှိပြီး အောက်ပါအဆင့်များသို့ တက်ဆုံးနိုင်သည်။`,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/mini.png',
          headerText: 'Mini',
          listArray: [`&bull; အမြန်ဆုငွေ: အများဆုံး $50 USD`, `&bull; Lucky Draw: Mini ဆုနဲ့အနိုင်ရနိုင်ခြေ`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/minor.png',
          headerText: 'Minor',
          listArray: [`&bull; အမြန်ဆုငွေ: အများဆုံး $250 USD`, `&bull; Lucky Draw: Minor ဆုနဲ့အနိုင်ရနိုင်ခြေ`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/major.png',
          headerText: 'Major',
          listArray: [`&bull; အမြန်ဆုငွေ: အများဆုံး $500 USD`, `&bull; Lucky Draw: Major ဆုနဲ့အနိုင်ရနိုင်ခြေ`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `Mini အဆင့်မှ အစပြုကာ turnover များနှင့် ticket များကို စုဆောင်းပြီး
    နောက်ထပ်အဆင့်များသို့ တက်ကြမည်။`,
        class: 'inline ',
      },
    ],
    bd: [
      {
        value: `আমাদের গেমে স্বাগতম!`,
        class: 'h1',
      },
      {
        value: `গেমটি কীভাবে কাজ করে তা সহজে বুঝতে নিচের নির্দেশনা দেখুন।`,
        class: 'h2',
      },
      {
        value: `1. <span class="bold text-white">Ante ফি${taxDisplay}:</span> প্রতিবার বাজি ধরলে বাজির একটি ছোট অংশ
    ante fee হিসেবে সংগ্রহ করা হয়। এই ফি জমা হয়ে একটি পুরস্কার তহবিল তৈরি করে।`,
      },
      {
        value:
          'নোট: ড্র-তে বাজি ধরলে কোনো অ্যান্টি ফি লাগবে না এবং এটি জ্যাকপট অগ্রগতিতে গণনা হবে না। ফাইট ড্র হলে বা বাতিল হলে <span class="bold text-red">Banker</span>/<span class="bold text-blue">Player</span> বাজি অ্যান্টি ফিসহ সম্পূর্ণ রিফান্ড করা হবে। ',
      },
      {
        value: `2. <span class="bold text-white">Jackpot Games:</span> সংগ্রহকৃত ante ফি গুলো একত্র হয়ে
    jackpot pool তৈরি হয় এবং বিভিন্ন jackpot game এ অংশগ্রহণ করে জেতার সুযোগ থাকে।`,
      },
      {
        value: `3. <span class="bold text-white">How to Win:</span> বর্তমান jackpot game এ নির্দিষ্ট turnover
    পূরণ করলে আপনি একটি ticket পাবেন। Ticket পেলেই আপনি prize pool থেকে তৎক্ষণাৎ payout পাবেন।
    Event শেষে সব ticket lucky draw তে যুক্ত হবে এবং এলোমেলোভাবে বিজয়ী নির্বাচন করা হবে।
    আপনার ticket নির্বাচিত হলে অতিরিক্ত পুরস্কার জেতার সুযোগ রয়েছে।`,
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/lucky-draw-instant-prize-custom.webp`,
        type: 'image',
        class: 'w-full desktop',
      },
      {
        value: `খেলতে খেলতে আপনি শুধু ব্যক্তিগত পুরস্কার জেতার সুযোগ পান না,
    বরং jackpot তহবিলেও অবদান রাখেন। এটি একটি মজার ও উত্তেজনাপূর্ণ খেলার অভিজ্ঞতা
    যেখানে বিশাল পুরস্কার জেতার সম্ভাবনা থাকে।`,
        class: 'inline ',
      },
      {
        value: 'Jackpot Game এর জন্য Progress জমা হওয়া',
        class: 'h1',
      },
      {
        value: `প্রতিবার খেলার সাথে সাথে jackpot game সক্রিয় হওয়ার দিকে
    আপনার progress বাড়তে থাকে। এটি meter এর মাধ্যমে প্রদর্শিত হয়।`,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/progress-en.webp`,
        type: 'image',
        class: 'w-full',
      },
      {
        value: 'Ticket Tiers সম্পর্কে বোঝা: Minor, Mini এবং Major',
        class: 'h1',
      },
      {
        value: `বাজির turnover অনুযায়ী ticket পাওয়া যায় এবং নিচের tier গুলোতে অগ্রসর হওয়া যায়।`,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/mini.png',
          headerText: 'Mini',
          listArray: [`&bull; তৎক্ষণাৎ payout: সর্বোচ্চ $50 USD`, `&bull; Lucky Draw: Mini payout জেতার সুযোগ`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/minor.png',
          headerText: 'Minor',
          listArray: [`&bull; তৎক্ষণাৎ payout: সর্বোচ্চ $250 USD`, `&bull; Lucky Draw: Minor payout জেতার সুযোগ`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/major.png',
          headerText: 'Major',
          listArray: [`&bull; তৎক্ষণাৎ payout: সর্বোচ্চ $500 USD`, `&bull; Lucky Draw: Major payout জেতার সুযোগ`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `Mini tier থেকে শুরু করে turnover ও ticket সংখ্যা পূরণ করে
    ধাপে ধাপে উচ্চ tier এ যেতে হবে।`,
        class: 'inline ',
      },
    ],
    in: [
      {
        value: `हमारे खेल में आपका स्वागत है! यह कैसे काम करता है, यह समझने में आपकी मदद करने के लिए यहां एक सरल मार्गदर्शिका दी गई है:`,
        class: 'h1',
      },
      {
        value: `1. <span class="bold text-white">पूर्व शुल्क${taxDisplay}:</span>  हर बार जब आप दांव लगाते हैं, तो एक छोटा प्रतिशत
      <span class="bold"></span> आपकी शर्त की राशि का एक हिस्सा पूर्व शुल्क के रूप में लिया जाता है। ये शुल्क मिलकर एक पुरस्कार राशि बनाते हैं।`,
      },
      {
        value:
          'नोट: ड्रॉ पर दांव लगाने पर कोई पूर्व शुल्क नहीं लगेगा और यह जैकपॉट प्रगति में नहीं गिना जाएगा। अगर फाइट ड्रॉ होती है या रद्द होती है, तो <span class="bold text-red">Banker</span>/<span class="bold text-blue">Player</span> दांव किसी भी पूर्व शुल्क सहित पूरी तरह वापस किए जाएंगे। ',
      },
      {
        value: `2. <span class="bold text-white">जैकपॉट गेम्स:</span> एकत्रित की गई पूर्व-शुल्क राशि को मिलाकर एक जैकपॉट बनाया जाता है। सदस्यों के पास विभिन्न जैकपॉट खेलों में भाग लेकर इस जैकपॉट को जीतने का मौका होता है।`,
      },
      {
        value: `3. <span class="bold text-white">कैसे जितना:</span> हमारे वर्तमान सक्रिय जैकपॉट गेम में, सदस्य अपनी बेट्स के ज़रिए कुछ टर्नओवर आवश्यकताओं को पूरा करने पर एक टिकट जीतते हैं। टिकट मिलने पर, आपको तुरंत पुरस्कार राशि मिल जाती है। इवेंट के अंत में, सभी टिकटों को एक लकी ड्रॉ में डाला जाता है जहाँ विजेताओं का चयन रैंडमली किया जाता है। अगर आपका टिकट चुना जाता है, तो आप अतिरिक्त पुरस्कार जीतते हैं!`,
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/lucky-draw-instant-prize-custom.webp`,
        type: 'image',
        class: 'w-full desktop',
      },
      {
        value: `तो, खेलकर और दांव लगाकर, आपको न केवल व्यक्तिगत पुरस्कार जीतने का मौका मिलता है, बल्कि आप सामूहिक जैकपॉट में भी योगदान करते हैं। यह खेल का आनंद लेने और संभावित रूप से बड़े पुरस्कार जीतने का एक मज़ेदार और रोमांचक तरीका है!`,
        class: 'inline ',
      },
      {
        value: 'जैकपॉट गेम के लिए प्रगति संचित करना',
        class: 'h1',
      },
      {
        value: `हर बार जब आप खेलते हैं, तो आप जैकपॉट गेम शुरू करने की दिशा में आगे बढ़ते हैं। यह प्रगति एक मीटर के ज़रिए मापी जाती है जो हर बार आपके दांव लगाने पर थोड़ा और भर जाता है।`,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/progress-en.webp`,
        type: 'image',
        class: 'w-full',
      },
      {
        value: 'टिकट स्तरों को समझना: माइनर, मिनी और मेजर',
        class: 'h1',
      },
      {
        value: `जैसे-जैसे सदस्य सट्टेबाजी में शामिल होते हैं, वे अपने सट्टेबाजी कारोबार के आधार पर टिकट अर्जित करते हैं, जो निम्न स्तरों के माध्यम से आगे बढ़ता है:`,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/mini.png',
          headerText: 'मिनी',
          listArray: [`&bull; तत्काल भुगतान: $50 USD तक कमाएँ`, `&bull; लकी ड्रा: मिनी पेआउट जीतने का मौका`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/minor.png',
          headerText: 'नाबालिग',
          listArray: [`&bull; तत्काल भुगतान: $250 USD तक कमाएँ`, `&bull; लकी ड्रा: मामूली भुगतान जीतने का मौका`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/major.png',
          headerText: 'प्रमुख',
          listArray: [`&bull; तत्काल भुगतान: $500 USD तक कमाएँ`, `&bull; लकी ड्रा: बड़ा भुगतान जीतने का मौका`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `मिनी स्तर से शुरुआत करें और टर्नओवर आवश्यकताओं को पूरा करते हुए तथा प्रत्येक स्तर पर आवश्यक संख्या में टिकट एकत्रित करते हुए आगे बढ़ें।`,
        class: 'inline ',
      },
    ],
    hant: [
      {
        value: `欢迎来到我们的游戏`,
        class: 'h1',
      },
      {
        value: `歡迎來到我們的遊戲！以下是一份簡單的指南，幫助您了解遊戲規則`,
        class: 'h2',
      },
      {
        value: `1. <span class="bold text-white">底注${taxDisplay}:</span> 每次下注，都會有一小部分百分比
      <span class="bold"></span> 您的投注金額的一部分將作為底注費收取。這些費用累積起來形成獎金池`,
      },
      {
        value:
          '注意：投注<span class="bold text-green">平局</span>不收取底注，也不計入獎池進度。若賽事結果為平局或取消，<span class="bold text-red">莊</span>/<span class="bold text-blue">閒</span>投注將全額退還，包括任何底注。',
      },
      {
        value: `2. <span class="bold text-white">累積獎金遊戲:</span> 收取的投注費將匯集起來形成獎金池。會員可以透過參與各種獎金池遊戲來贏得該獎金池的獎金。`,
      },
      {
        value: `3. <span class="bold text-white">如何獲勝：</span> 在我們目前正在進行的累積獎金遊戲中，會員透過投注達到一定的流水要求即可獲得彩票。獲得彩票後，您可以立即從獎金池中領取獎金。活動結束後，所有彩券將參與抽獎，隨機抽出中獎者。如果您的彩票被選中，您將贏得額外獎品！`,
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/lucky-draw-instant-prize-custom.webp`,
        type: 'image',
        class: 'w-full desktop',
      },
      {
        value: `所以，透過參與遊戲和下注，您不僅有機會贏得個人獎項，還能為集體獎金池貢獻一份力量。這是一種既有趣又刺激的遊戲方式，還有機會贏得豐厚獎勵！`,
        class: 'inline ',
      },
      {
        value: '累積獎金遊戲進度',
        class: 'h1',
      },
      {
        value: `每次遊戲，你都會朝著觸發累積獎金遊戲的目標邁進。這個進度會透過一個計量表來顯示，每次下注都會讓計量表填滿一點。`,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `game-help/jackpot/progress-en.webp`,
        type: 'image',
        class: 'w-full',
      },
      {
        value: '了解票務等級：小票、迷你票和大票',
        class: 'h1',
      },
      {
        value: `會員參與投注後，可依投注額獲得門票，並依下列方式晉升等級：`,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/mini.png',
          headerText: '小型的',
          listArray: [`&bull; 即時提現：最高可賺取 50 美元`, `&bull; 抽獎：有機會贏取小額獎金`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/minor.png',
          headerText: '次要的',
          listArray: [`&bull; 即時支付：最高可賺取 250 美元`, `&bull; 抽獎：有機會贏取小額獎金`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/major.png',
          headerText: '主要的',
          listArray: [`&bull; 即時支付：最高可賺取 500 美元`, `&bull; 抽獎：有機會贏取巨額獎金`],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },
      {
        value: `從迷你等級開始，透過滿足每個等級的營業額要求並收集所需數量的門票，逐步晉升。`,
        class: 'inline ',
      },
    ],
    uz: [
      {
        value: `O'yinimizga xush kelibsiz!`,
        class: 'h1',
      },
      {
        value: `Uning qanday ishlashini tushunishingizga yordam beradigan oddiy qo'llanma:`,
        class: 'h2',
      },
      {
        value: `1. <span class="bold text-white">Ante to'lovlari${taxDisplay}:</span> Har safar pul tikishda, garovingiz miqdorining kichik foizi oldindan to'lov sifatida yig'iladi. Bu to'lovlar yig'ilib, sovrin jamg'armasini yaratadi.`,
      },
      {
        value: `Eslatma: <span class="bold text-green">Draw</span> garovida ante to'lovi va jackpot o'sishi yo'q. <span class="bold text-red">Banker</span>/<span class="bold text-blue">Player</span> garovlari, agar jang Draw bilan yakunlansa yoki bekor qilinsa, ante to'lovini ham o'z ichiga olgan holda to'liq qaytariladi.`,
      },
      {
        value: `2. <span class="bold text-white">Jackpot o'yinlari:</span> Yig'ilgan ante to'lovlari jackpotni hosil qilish uchun birlashtiriladi. A'zolar turli jackpot o'yinlarida ishtirok etib, ushbu jackpotdan yutib olish imkoniyatiga ega.`,
      },
      {
        value: `3. <span class="bold text-white">Qanday qilib yutish mumkin:</span> Hozirgi faol jackpot o'yinimizda a'zolar garovlari orqali ma'lum aylanma talablariga javob berganlarida chipta yutib olishadi. Chiptangiz bo'lgandan so'ng, siz darhol sovrin jamg'armasidan to'lovni olasiz. Tadbir oxirida barcha chiptalar omadli o'yinda ishtirok etadi, bu yerda g'oliblar tasodifiy ravishda tanlanadi. Agar sizning chiptangiz tanlansa, siz qo'shimcha sovrinlarni yutib olasiz!`,
      },
      {
        value: '<br />',
        class: 'break',
      },

      // Lucky Draw image
      {
        value: `game-help/jackpot/lucky-draw-instant-prize-custom.webp`,
        type: 'image',
        class: 'w-full desktop',
      },

      {
        value: `Shunday qilib, o'ynash va pul tikish orqali siz nafaqat individual sovrinlarni yutib olish imkoniyatiga ega bo'lasiz, balki umumiy jackpotga ham hissa qo'shasiz. Bu o'yindan zavqlanish va katta mukofotlarni yutib olishning qiziqarli va hayajonli usuli!`,
        class: 'inline ',
      },

      {
        value: `Jackpot o'yinida to'plangan yutuqlar`,
        class: 'h1',
      },
      {
        value: `Har safar o'ynaganingizda, siz jackpot o'yinini ishga tushirish yo'lida oldinga siljiysiz. Bu o'sish har safar pul tikishda biroz ko'proq to'ldiriladigan hisoblagich orqali o'lchanadi.`,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },

      // Progress image
      {
        value: `game-help/jackpot/progress-en.webp`,
        type: 'image',
        class: 'w-full',
      },

      {
        value: `Chipta darajalarini tushunish: Minor, Mini va Major`,
        class: 'h1',
      },
      {
        value: `A'zolar garov o'ynashda ishtirok etganlarida, ular garov aylanmasi asosida chiptalarni quyidagi bosqichlardan o'tib olishadi:`,
        class: 'inline ',
      },
      {
        value: '<br />',
        class: 'break',
      },

      // Mini image + content
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/mini.png',
          headerText: 'Mini',
          listArray: [
            `&bull; Tezkor to'lov: 50 AQSh dollarigacha pul ishlang`,
            `&bull; Omadli o'yin: Mini to'lovni yutib olish imkoniyati`,
          ],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },

      // Minor image + content
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/minor.png',
          headerText: 'Minor',
          listArray: [
            `&bull; Tezkor to'lov: 250 AQSh dollarigacha pul ishlang`,
            `&bull; Omadli o'yin: Minor to'lovni yutib olish imkoniyati`,
          ],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },

      // Major image + content
      {
        type: 'left-image-template',
        config: {
          link: 'game-help/jackpot/major.png',
          headerText: 'Major',
          listArray: [
            `&bull; Tezkor to'lov: 500 AQSh dollarigacha pul ishlang`,
            `&bull; Omadli o'yin: Major to'lovni yutib olish imkoniyati`,
          ],
        },
      },
      {
        value: '<br />',
        class: 'break',
      },

      {
        value: `Mini darajasidan boshlang va aylanma talablarini bajarish hamda har bir darajada kerakli miqdordagi chiptalarni to'plash orqali yuqoriga ko'taring.`,
        class: 'inline ',
      },
    ],
  };

  if (language && language in guides) {
    return guides[language as keyof typeof guides];
  }
  return guides;
};
